export default {
    "goods_category_page_title": "商品分类",
    "goods_category_product": "商品",
    "goods_category_default": "默认",
    "goods_category_sales": "销量",
    "goods_category_filter_brand": "筛选品牌",
    "goods_category_brand": "品牌",
    "goods_category_sub_brand": "子品牌",
    "goods_category_reset": "重置",
    "goods_category_confirm": "确认",
    "goods_category_retry": "重新加载",
    "goods_category_page_load_failed": "商品分类加载失败",
    "goods_category_child_load_failed": "子分类加载失败",
    "goods_category_brand_load_failed": "品牌加载失败",
    "goods_category_goods_load_failed": "商品加载失败",
    "goods_category_empty_category": "暂无商品分类",
    "goods_category_empty_category_desc": "请稍后再试",
    "goods_category_empty_child": "暂无子分类",
    "goods_category_empty_goods": "暂无商品",
    "goods_category_empty_goods_desc": "试试其他分类或品牌",
    "goods_category_load_more_failed": "加载失败，点击重试",
    "goods_category_no_more": "已加载全部商品",
    "goods_category_promotion_price": "促销价",
    "goods_category_tomo_price": "TOMO价",
    "just_a_bit": "一下吧",
    "not_damaged_at_all": "一点没损坏",
    "level_1_category": "一级分类",
    "lets_browse_shop_together": "一起逛逛这家店吧",
    "one_click_bind": "一键绑定",
    "seven_day_lord": "七日领主",
    "ten_thousand": "万",
    "ten_thousand_yuan": "万元",
    "mixc_mall": "万象城",
    "three_weeks_full_attendance": "三周全勤铸就不朽功绩",
    "three_days_company": "三日相伴",
    "three_days_company_reward": "三日相伴收获颇丰",
    "context": "上下文",
    "uploading": "上传中",
    "uploading_mask": "上传中蒙层",
    "upload_voucher": "上传凭证",
    "upload_face_image_failed": "上传刷脸图片失败",
    "upload_response_format_error": "上传响应格式错误",
    "upload_after_sales_desc_hint": "上传售后描述有助处理问题",
    "upload_image": "上传图片",
    "upload_failed": "上传失败",
    "upload_id_card_hint": "上传身份证可自动识别信息",
    "upload_unknown_error": "上传过程中发生未知错误",
    "upload_bank_card_hint": "上传银行卡可自动识别信息",
    "pull_up_to_load_more": "上拉加载更多",
    "shanghai_city": "上海市",
    "next_step": "下一步",
    "next_step_button": "下一步按钮",
    "order_time": "下单时间",
    "download": "下载",
    "downloading": "下载中",
    "download_all_images_and_copy_info": "下载全部商品图并复制商品信息",
    "download_all_button": "下载全部按钮",
    "download_to_album": "下载到相册",
    "download_not_implemented": "下载功能暂未实现",
    "after_download": "下载后",
    "download_product_image": "下载商品图",
    "download_images_publish_hint": "下载商品图和商品信息发布自己的平台",
    "download_image_failed": "下载图片失败",
    "download_url_not_configured": "下载地址未配置",
    "download_url_config_loaded": "下载地址配置加载成功",
    "download_url_config_updated": "下载地址配置已更新",
    "download_failed": "下载失败",
    "download_success": "下载成功",
    "download_button": "下载按钮",
    "download_poster": "下载海报",
    "download_poster_share_moment": "下载海报发布朋友圈",
    "download_poster_button": "下载海报按钮",
    "download_certificate": "下载证书",
    "download_timeout": "下载超时",
    "download_territory": "下载领地",
    "download_territory_code": "下载领地码",
    "not_just_joining": "不只是加入",
    "no_decimals_allowed": "不可以输入小数",
    "cannot_close": "不可关闭",
    "disagree": "不同意",
    "refund_not_supported": "不支持退款",
    "show_none_selected": "不显示任何已选择",
    "cannot_select_more_than": "不能选择超过",
    "unlimited": "不限",
    "unlimited_people": "不限人数",
    "unlimited_stock": "不限库存",
    "distributor_scroll_list": "与分销员滚动列表",
    "exclusive_task": "专属任务",
    "exclusive_params": "专属参数",
    "exclusive_digital_space": "专属数字空间",
    "exclusive_identity": "专属身份",
    "exclusive_identity_badge": "专属身份标识",
    "and_agree_to_protocols": "且代表您已同意以下协议",
    "and_allow_comments": "且允许注释",
    "business_metrics": "业务指标",
    "justify_between": "两边定位",
    "strictly_selected_goods": "严选好物",
    "count_unit": "个",
    "events_count": "个事件",
    "personal": "个人",
    "personal_center": "个人中心",
    "personal_updates": "个人动态",
    "personal_contribution": "个人贡献值",
    "personal_contribution_detail": "个人贡献值明细",
    "personal_contribution_desc": "个人贡献值说明",
    "personal_assets": "个人资产",
    "tasks_count": "个任务",
    "products_count": "个商品",
    "after_sales_reason_required": "个商品的售后理由不能为空",
    "product_status_required": "个商品的货物状态不能为空",
    "refund_amount_required": "个商品的退款金额不能为空",
    "refund_amount_format_error": "个商品的退款金额格式不正确",
    "signature": "个性签名",
    "digital_assets_pending": "您有{count}个数字资产待领取",
    "merchant_audit_failed_msg": "很遗憾, 你的商家认证审核未通过, 原因如下：",
    "store_audit_failed_msg": "很遗憾, 你的门店认证审核未通过, 原因如下：",
    "merchant_audit_success_msg": "恭喜，你的商家认证审核已通过",
    "store_join_success_msg": "恭喜，你的门店已入驻领地",
    "if_join_store_guide": "如果你需要入驻门店，请点击下方按钮进行操作。",
    "store_manage_guide": "你可通过微信搜索“领地联营”小程序,输入短信中的用户名与密码,进行门店管理。",
    "digital_wallet_guide": "点击下方按钮，开通数字钱包，即可免费领取数字资产，享受专属权益",
    "explore_new_world_msg": "快去领地探索新世界吧~",
    "gift_check_guide": "{content}，点击下方按钮查看",
    "download_to_join_msg": "下载领地App，持有数字商品，即可加入",
    "activities_count": "个活动",
    "red_packets_total": "个红包共",
    "territory_members_holding_this": "个领地成员持有该",
    "territory_members_holding_asset": "个领地成员持有该数字资产",
    "taiwan_residents": "中国台湾居民",
    "mainland_residents": "中国大陆居民",
    "macau_residents": "中国澳门居民",
    "cmcc_auth_terms": "中国移动认证服务条款",
    "hongkong_residents": "中国香港居民",
    "mapped_to_in": "中映射为",
    "not_found_in": "中没有找到",
    "middle_section": "中部区域",
    "configured_in": "中配置",
    "center": "中间",
    "center_bump": "中间一个鼓包",
    "center_text_info": "中间文本信息",
    "center_bulge": "中间鼓包",
    "temp_closed": "临时闭店",
    "protect_rights": "为保障你的合法权益",
    "protect_your_rights": "为保障您的权益",
    "protect_account_assets": "为保障您的账户与资产安全",
    "convenience_for_developers": "为方便更多开发者使用",
    "main_dist_detail": "主分销详情",
    "main_image_area": "主图片区域",
    "main_dist_product_detail": "主态分销商品详情",
    "main_dist_detail_short": "主态分销商详",
    "main_content": "主要内容",
    "main_content_area": "主要内容区域",
    "main_notice_bar": "主通知栏",
    "home_page": "主页",
    "report": "举报",
    "report_success": "举报成功",
    "event_queued": "事件已加入队列",
    "event_sent": "事件已发送",
    "event_passed": "事件通过",
    "event_retry": "事件重试",
    "event_retry_limit": "事件重试次数已达上限",
    "qrcode": "二维码",
    "qrcode_saved": "二维码保存成功",
    "qrcode_content_required": "二维码内容不能为空",
    "qrcode_area": "二维码区域",
    "qrcode_desc": "二维码描述",
    "qrcode_display_area": "二维码显示区域",
    "qrcode_generating": "二维码生成中",
    "yunnan_signboard": "云南招牌",
    "yunnan_restaurant_available": "云南精选餐厅可用",
    "mutual_follow_action": "互关",
    "interaction_data_row": "互动数据行",
    "mutual_follow": "互相关注",
    "five_star_rating": "五星好评",
    "transaction_list": "交易列表",
    "transaction_no": "交易单号",
    "transaction_cancelled": "交易取消",
    "transaction_count": "交易数量",
    "enjoy_exclusive_rights": "享受专属权益",
    "person": "人",
    "people_distributed": "人分销过",
    "people_participated": "人参加",
    "people_collaborated": "人合作过",
    "personnel_list_container": "人员列表容器",
    "people_consulted": "人咨询过",
    "people_online": "人在线",
    "people_joined": "人已加入",
    "people_registered": "人已报名",
    "people_holding": "人已持有",
    "people_brought": "人带过",
    "people_hold": "人持有",
    "people_chatting": "人正在热聊",
    "people_operating": "人正在联营",
    "connections": "人脉",
    "connection_coorperation": "人脉合作",
    "connection_skills": "人脉技能",
    "face_auth": "人脸认证",
    "face_verify_success": "人脸验证成功",
    "people_earned_commission": "人获得佣金",
    "people_liked_post": "人赞了你的动态",
    "people_liked_comment": "人赞了你的评论",
    "people_booked": "人预约",
    "people_dining": "人餐",
    "what_is_contribution": "什么是个人贡献值",
    "what_is_digital_assets": "什么是数字权益资产",
    "what_is_estimated_commission": "什么是预估佣金",
    "left_nothing": "什么都没有留下",
    "fallback_only": "仅作为回退",
    "only_left": "仅剩",
    "wechat_only_and": "仅在微信内且",
    "button_only": "仅按钮",
    "refund_only": "仅退款",
    "today": "今天",
    "today_purchasable": "今日可购买",
    "today_purchase_limit_reached": "今日可购买次数已用完",
    "today_earnings": "今日收益",
    "today_order": "今日第",
    "today_checkin_reward": "今日签到奖励",
    "today_invite_count": "今日邀请人数",
    "intro_no_politics": "介绍中请勿含有涉及政治",
    "from": "从",
    "from_own_showcase": "从自己的橱窗",
    "transparent_to_black": "从透明到黑色",
    "territories_he_joined": "他加入的领地",
    "digital_assets_he_holds": "他持有的数字资产",
    "payment_time": "付款时间",
    "help_fill_logistics": "代填写物流信息",
    "voucher": "代金券",
    "voucher_product": "代金券商品",
    "following": "以下",
    "following_content_depend_on": "以下内容请根据选择的",
    "dashboard": "仪表盘",
    "piece": "件",
    "items_product": "件商品",
    "value": "价值",
    "value_burst": "价值全面迸发",
    "price": "价格",
    "price_info": "价格信息",
    "price_info_card": "价格信息卡片",
    "price_area": "价格区域",
    "price_and_quantity": "价格和数量",
    "price_number": "价格数字",
    "price_display": "价格显示",
    "task": "任务",
    "place_to_win_attention": "任务就能赢得众人瞩目的地方",
    "task_square": "任务广场",
    "portion": "份",
    "discount_info": "优惠信息",
    "coupon": "优惠券",
    "coupon_info": "优惠券信息",
    "coupon_content": "优惠券内容",
    "coupon_list": "优惠券列表",
    "coupon_tag": "优惠券标签",
    "member": "会员",
    "member_operation_desc": "会员运营沉淀流量资产渠道分销驱动复购增长",
    "everyday_at": "会在每天",
    "recommend_to_friend": "会推荐给朋友",
    "bit": "位",
    "above_separator": "位于分割线上方",
    "member_count_unit": "位成员",
    "digit_verification_code": "位数字验证码",
    "location": "位置",
    "low_price_recharge_scam": "低价充值等言论",
    "experience": "体验",
    "merchants_available": "余家商户可用",
    "balance": "余额",
    "balance_display": "余额显示",
    "author": "作者",
    "author_reply": "作者回复",
    "author_liked": "作者赞过",
    "search_via_wechat": "你可通过微信搜索",
    "hello": "你好",
    "level_image_cool": "你的专属等级形象就越炫酷",
    "identity_badge_display": "你的专属身份标识将直接显示在你的头像旁",
    "merchant_auth_approved": "你的商家认证审核已通过",
    "merchant_auth_rejected": "你的商家认证审核未通过",
    "friend_shared_post": "你的好友分享了一篇领地动态",
    "digital_identity_waiting": "你的数字身份正在等你认领",
    "every_participation": "你的每一次参与",
    "every_contribution_convert": "你的每一次贡献都会转化为",
    "store_joined_territory": "你的门店已入驻领地",
    "store_auth_rejected": "你的门店认证审核未通过",
    "commission": "佣金",
    "commission_card": "佣金卡片",
    "commission_price_row": "佣金和价格行",
    "commission_data": "佣金数据",
    "commission_rate": "佣金率",
    "higher_commission": "佣金越高",
    "wear": "佩戴",
    "wear_success": "佩戴成功",
    "use": "使用",
    "use_main_image_as_thumb": "使用商品主图作为缩略图",
    "use_time": "使用时间",
    "usage_process": "使用流程",
    "usage_rules": "使用规则",
    "usage_record": "使用记录",
    "usage_instructions": "使用说明",
    "usage_notice": "使用须知",
    "use_default_config": "使用默认配置",
    "promotion": "促销",
    "promotion_activity": "促销活动",
    "save": "保存",
    "saving": "保存中",
    "save_image": "保存图片",
    "save_failed": "保存失败",
    "save_avatar": "保存头像",
    "save_success": "保存成功",
    "save_to_album": "保存至相册",
    "secret": "保密",
    "info_area": "信息区域",
    "info_error": "信息有误",
    "modify": "修改",
    "modify_after_sales_apply": "修改售后申请",
    "modify_after_sales_submitted": "修改售后申请已提交",
    "modify_failed": "修改失败",
    "modify_account_info": "修改开户信息",
    "modify_success": "修改成功",
    "modify_address": "修改收货地址",
    "modify_nickname": "修改昵称",
    "modify_tags": "修改标签",
    "modify_application": "修改申请",
    "modify_signature": "修改签名",
    "modify_profile": "修改资料",
    "modify_territory_name": "修改领地名称",
    "countdown": "倒计时",
    "parking": "停车",
    "yuan": "元",
    "yuan_all_category_voucher": "元全品类代金券",
    "yuan_available": "元可用",
    "full_energy_checkin": "元气满满来签到了",
    "element": "元素",
    "yuan_red_packet_await": "元红包与专属权益等你来拿",
    "yuan_dining_voucher": "元餐饮通用券",
    "recharge": "充值",
    "confirm_age_before_recharge": "充值前请确认已满",
    "recharge_protocol_hint": "充值协议提示",
    "recharge_failed": "充值失败",
    "recharge_exception": "充值异常",
    "recharge_success": "充值成功",
    "recharge_button": "充值按钮",
    "recharge_buffer_time_hint": "充值购买需要缓冲时间",
    "recharge_options_grid": "充值选项网格",
    "recharge_diamond": "充值领钻",
    "delete_one_first": "先删除一个吧",
    "served_first": "先到先得",
    "free": "免费",
    "no_reservation_needed": "免预约",
    "join_store": "入驻门店",
    "nationwide_chain": "全国连锁",
    "available_all_day": "全天可用",
    "fullscreen_overlay": "全屏覆盖显示",
    "store_wide_use": "全店通用",
    "visible_to_all_users": "全站用户都能看到",
    "select_all": "全选",
    "all": "全部",
    "all_products": "全部商品",
    "all_combos": "全部套餐",
    "all_shops": "全部店铺",
    "withdraw_all": "全部提现",
    "all_messages": "全部消息",
    "all_orders": "全部订单",
    "all_stores": "全部门店",
    "public_channel": "公共频道",
    "company": "公司",
    "km": "公里",
    "total": "共",
    "total_discount": "共优惠",
    "total_profit_share": "共分润",
    "boost_brand_value_together": "共同提升品牌价值",
    "governance_profit_share": "共治分润",
    "total_saved": "共省",
    "about_us": "关于我们",
    "about_territory": "关于领地",
    "follow": "关注",
    "followed_you": "关注了你",
    "follow_success": "关注成功",
    "follow_button": "关注按钮",
    "follow_messages": "关注消息",
    "follow_related": "关注相关",
    "relation_graph_area": "关系图区域",
    "relation_graph_canvas": "关系图画布",
    "close": "关闭",
    "close_button": "关闭按钮",
    "interest_tags": "兴趣标签",
    "others": "其他",
    "other_country_residents": "其他国家或地区居民",
    "other_icons_list": "其他图标列表",
    "other_miniapps_via": "其他小程序通过",
    "others_unchanged": "其他我没改",
    "login_other_phone": "其他手机号登录",
    "other_share_page_types": "其他类型的分享页面",
    "other_rules": "其他规则",
    "other_pages_no_setting": "其他页面不需要设置",
    "compatible": "兼容",
    "content": "内容",
    "content_empty": "内容为空",
    "content_unchanged": "内容保持不变",
    "content_share_card": "内容分享卡片",
    "content_area": "内容区域",
    "content_card_template": "内容卡片模板",
    "content_customizable": "内容可自定义",
    "content_and_comments": "内容和评论",
    "content_image": "内容图片",
    "content_cover": "内容封面",
    "content_layer": "内容层",
    "content_box": "内容盒子",
    "content_details": "内容详情",
    "content_part": "内容部分",
    "even_the_smallest_individual": "再小的个体",
    "order_again": "再来一单",
    "verify_again": "再次认证",
    "try_again": "再试一次",
    "minus": "减",
    "top_seller": "出单达人",
    "minute": "分",
    "share": "分享",
    "sharing": "分享中",
    "share_to_miniapp_failed": "分享到微信小程序失败",
    "share_card": "分享卡片",
    "share_card_failed": "分享卡片失败",
    "share_monetization": "分享变现",
    "share_product": "分享商品",
    "share_failed": "分享失败",
    "share_miniapp_card_image": "分享小程序卡片主图",
    "share_guide_modal": "分享引导弹窗",
    "share_modal": "分享弹窗",
    "share_modal_component": "分享弹窗组件",
    "share_wechat": "分享微信",
    "share_button": "分享按钮",
    "share_button_area": "分享按钮区域",
    "share_moments": "分享朋友圈",
    "share_poster": "分享海报",
    "share_component": "分享组件",
    "share_interesting_user": "分享给你一个超有趣的领地用户",
    "share_to_friends": "分享给好友",
    "share_to": "分享至",
    "share_earn_money": "分享赚钱",
    "divider": "分割线",
    "split_percentage": "分成",
    "analyzing_image_color": "分析图片颜色中",
    "profit_share": "分润",
    "category_selector": "分类选择器",
    "group_button": "分组按钮",
    "group_title": "分组标题",
    "minutes": "分钟",
    "minutes_ago": "分钟前",
    "sold_out_in_minutes": "分钟被抢光",
    "distributor_list": "分销员列表",
    "distributor_status": "分销员状态",
    "distributor_level": "分销员等级",
    "distributor_product_page": "分销商品专用页面",
    "distribute_group_buy": "分销团购商品",
    "distribute_group_buy_detail": "分销团购商品详情",
    "distribute_group_detail": "分销团购详情",
    "distribute_earn_commission": "分销得佣金",
    "distribute_max_earn": "分销最高可赚",
    "distribution_module": "分销模块",
    "distribute_this_product": "分销此商品",
    "distribute_retail_product": "分销零售商品",
    "distribute_retail_product_detail": "分销零售商品详情",
    "separator": "分隔符",
    "separator_line": "分隔线",
    "switch": "切换",
    "switch_failed": "切换失败",
    "switch_nav": "切换导航",
    "switch_login": "退出登录",
    "list": "列表",
    "just_now": "刚刚",
    "create": "创作",
    "creator": "创作者",
    "create_verb": "创建",
    "create_new_territory": "创建新领地",
    "create_time": "创建时间",
    "creator_noun": "创建者",
    "create_order_event": "创建订单事件",
    "create_territory": "创建领地",
    "init_share_data_failed": "初始化分享数据失败",
    "init_failed": "初始化失败",
    "init_completed": "初始化完成",
    "init_config_params": "初始化配置参数",
    "delete": "删除",
    "deleting": "删除中",
    "delete_in_detail_page": "删除功能请在详情页操作",
    "delete_post_warning": "删除后此条动态在所有场景均消失",
    "delete_address": "删除地址",
    "delete_success": "删除成功",
    "free_gift_in_store": "到店消费可免费获赠",
    "checkin_post_after_store_visit": "到店消费后发布动态打卡",
    "final_price": "到手价",
    "final_price_text": "到手价文字",
    "arrival_bank_card": "到账银行卡",
    "refresh_success": "刷新成功",
    "coupon_code": "券码",
    "open_browser_paste": "前往浏览器粘贴并打开",
    "remaining": "剩余",
    "remaining_stock": "剩余库存",
    "remaining_payment_time": "剩余支付时间",
    "join": "加入",
    "add_to_showcase_failed": "加入橱窗失败",
    "add_to_cart": "加入购物车",
    "join_territory": "加入领地",
    "join_territory_interact": "加入领地与其他成员进行互动",
    "join_territory_pact": "加入领地公约",
    "join_territory_merchant_alliance": "加入领地商户联盟",
    "join_territory_success": "加入领地成功",
    "add_wechat_join_group": "加微信入群",
    "add_showcase": "加橱窗",
    "loading": "加载",
    "loading_status": "載入中",
    "loading_failed": "加载失败",
    "loading_hint": "加载提示",
    "load_more": "加载更多",
    "load_more_hint": "加载更多提示",
    "loading_state": "加载状态",
    "loading_indicator": "加载状态指示器",
    "add_selection_library": "加选品库",
    "accelerate_brand_value": "加速自我品牌价值提升",
    "moments": "动态",
    "dynamic_recharge": "动态充值",
    "dynamic_param_trigger": "动态参数触发",
    "dynamic_param_trigger_failed": "动态参数触发失败",
    "dynamic_param_trigger_completed": "动态参数触发完成",
    "moment_posted": "动态发布成功",
    "moment_deleted": "动态已删除",
    "moment_detail": "动态详情",
    "moments_channel": "动态频道",
    "animation_container": "动画容器",
    "medal": "勋章",
    "wrap_container_for_animation": "包一层容器用于动画",
    "well_packaged": "包装严实",
    "exquisite_packaging": "包装精致",
    "free_shipping": "包邮",
    "beijing": "北京市",
    "beijing_territory": "北京领地",
    "craftsmanship": "匠心工艺",
    "district": "区",
    "district_county": "区县",
    "district_list": "区县列表",
    "district_level": "区县级别",
    "blockchain_collection_certificate": "区块链藏品证书",
    "blockchain_certificate": "区块链证书",
    "area": "区域",
    "area_content": "区域内容",
    "area_chart": "区域图",
    "ten_days_breakthrough": "十日坚持突破自我",
    "upgrade_identity": "升级身份",
    "half_year_sales": "半年售",
    "half_star": "半星",
    "halfway_champion": "半程桂冠",
    "negotiation_history": "协商历史",
    "protocol_content": "协议内容",
    "protocol_check": "协议勾选",
    "protocol_modal": "协议弹窗",
    "single": "单",
    "single_avatar": "单个头像",
    "single_amount": "单个金额",
    "sell_product_earn_commission": "卖出商品获得佣金",
    "placeholder": "占位",
    "card_area": "卡片区域",
    "card_container": "卡片容器",
    "card_size": "卡片尺寸",
    "card_template": "卡片模板",
    "card_background": "卡片背景",
    "place_order_now": "即可下单",
    "claim_digital_asset_free": "即可免费领取数字资产",
    "join_now": "即可加入",
    "join_this_territory_now": "即可加入该领地",
    "join_territory_now": "即可加入领地",
    "open_digital_wallet_now": "即可开通数字钱包",
    "become_distributor_open_wallet": "即可成为分销员并开通现金钱包",
    "reason": "原因",
    "reason_below": "原因如下",
    "original": "原始",
    "go_to_order": "去下单",
    "go_to_pay": "去付款",
    "go_to_use": "去使用",
    "go_to_recharge": "去充值",
    "go_to_share": "去分享",
    "go_share_moments": "去分享動態吧",
    "go_browse_elsewhere": "去别处逛逛吧~",
    "go_post": "去发帖",
    "go_activate": "去开通",
    "go_open": "去打开",
    "go_promote": "去推广",
    "go_pay": "去支付",
    "go_update": "去更新",
    "go_view": "去查看",
    "go_like": "去点赞",
    "go_checkin": "去签到",
    "go_settle": "去结算",
    "go_setting": "去设置",
    "go_comment": "去评论",
    "go_buy": "去购买",
    "go_gift": "去赠送",
    "go_invite": "去邀请",
    "go_claim": "去领取",
    "join_brand_alliance_earn": "参与品牌联营并获得收益",
    "join_alliance": "参与联营",
    "participate": "参加",
    "params": "参数",
    "in_params": "参数中",
    "params_failed": "参数失败",
    "params_error": "参数错误",
    "two_way_bind_search": "双向绑定搜索值",
    "sent_red_packets": "发出的红包",
    "post_moment": "发动态",
    "on_sale": "发售",
    "release_calendar": "发售日历",
    "posted_at": "发布于",
    "post_button": "发布按钮",
    "post_activity": "发布活动",
    "post_get_rewards_hint": "发帖有机会获得更多奖励哦",
    "post_show_off": "发帖炫耀一下",
    "send_danmu": "发弹幕",
    "post_service": "发服务",
    "post_event": "发活动",
    "invoice_apply": "发票申请",
    "send_red_packet": "发红包",
    "issue": "发行",
    "issue_info": "发行信息",
    "issue_platform": "发行平台",
    "issuer": "发行方",
    "ship": "发货",
    "shipping_origin": "发货地",
    "fast_shipping": "发货快",
    "initiate_and_host_success": "发起并成功举办",
    "send": "发送",
    "sending": "发送中",
    "send_location": "发送位置",
    "send_failed": "发送失败",
    "send_exception": "发送异常",
    "send_success": "发送成功",
    "send_red_envelope": "发送红包",
    "pick_a_loud_name": "取一个响亮的名称吧",
    "cancel": "取消",
    "unequip": "取消佩戴",
    "unfollow": "取消关注",
    "unfollow_failed": "取消关注失败",
    "unfollow_success": "取消关注成功",
    "unfollow_confirm_modal": "取消关注确认弹窗",
    "cancel_reason": "取消原因",
    "cancel_success": "取消成功",
    "cancel_button": "取消按钮",
    "cancel_payment": "取消支付",
    "cancel_time": "取消时间",
    "unlike": "取消点赞",
    "cancel_reason_text": "取消理由",
    "cancel_remove": "取消移除",
    "unpin": "取消置顶",
    "cancel_order": "取消订单",
    "cancel_order_failed": "取消订单失败",
    "cancel_order_success": "取消订单成功",
    "pickup_time": "取货时间",
    "monetize_revenue_sustainable": "变现收益持续化",
    "only_show": "只显示",
    "select_one_video_only": "只能选择一个视频",
    "can_upload_multiple": "可上传多张",
    "can_in": "可以在",
    "available": "可使用",
    "can_get_free": "可免费获赠",
    "can_at": "可在",
    "withdrawable_amount": "可提现金额",
    "replaceable": "可替换",
    "add_content_as_needed": "可根据需要添加内容",
    "can_perform": "可演出",
    "available_alt": "可用",
    "available_time": "可用时间",
    "available_stores": "可用门店",
    "maybe_invalid": "可能不是有效的",
    "proxy_config_error_maybe": "可能代理配置错误",
    "can_obtain": "可获得",
    "can_get_avatar_frame": "可获得头像框组件",
    "can_get_rewards": "可获得奖励",
    "can_earn": "可赚",
    "optional": "可选",
    "claim_initial_territory_medal": "可领取初始领地勋章",
    "claimable_rewards": "可领取奖励",
    "taiwan_resident_pass": "台湾居民证",
    "top_right_close_button": "右上角关闭按钮",
    "right_side": "右侧",
    "right_price_button": "右侧价格按钮",
    "right_content": "右侧内容",
    "right_area": "右侧区域",
    "right_icon": "右侧图标",
    "right_display": "右侧展示",
    "right_invited_info": "右侧已邀请信息",
    "right_button": "右侧按钮",
    "right_revenue_card": "右侧收益曲线卡",
    "right_text_part": "右侧文字部分",
    "right_column": "右列",
    "number": "号",
    "cooperation_location": "合作地点",
    "cooperation_square": "合作广场",
    "cooperation_poster": "合作海报",
    "cooperation_detail": "合作详情",
    "hopson_one": "合生汇",
    "total_sum": "合计",
    "same_day_available": "同一到同日可用",
    "agree_protocol_register": "同意协议并注册",
    "agree_recharge": "同意并充值",
    "agree_continue": "同意并继续",
    "peers": "同行",
    "no_politics_in_name": "名称中请勿含有涉及政治",
    "name_tags_area": "名称和标签区域",
    "people_checked_in": "名签到",
    "after": "后",
    "apply_after_sales_again_after": "后再次申请售后",
    "merchant_not_confirm_after_reapply": "后再次申请售后商家未确认",
    "merchant_not_confirm_after": "后商家未确认",
    "merchant_not_refund_after": "后商家未退款",
    "return_prev_page_after": "后将返回上级页面",
    "open_after": "后开启",
    "revoke_return_if_not_shipped_after": "后未寄出将撤销退货申请",
    "potential_refund_later": "后续用户可能存在退款情况",
    "auto_close_after": "后自动关闭",
    "upward_gradient_shadow": "向上渐变阴影",
    "show_code_to_merchant": "向商家出示二维码或券号即可消费",
    "question_mark": "吗",
    "else_show_back_arrow": "否则显示返回箭头",
    "startup_success": "启动成功",
    "bottom_cancel_button": "吸低取消按钮",
    "monday": "周一",
    "wednesday": "周三",
    "tuesday": "周二",
    "friday": "周五",
    "saturday": "周六",
    "thursday": "周四",
    "years_old": "周岁",
    "sunday": "周日",
    "and": "和",
    "and_miniapp": "和小程序",
    "unified_with_miniapp": "和小程序统一使用",
    "coffee_lover": "咖啡星人",
    "brand_intro": "品牌介绍",
    "brand_collab_opportunity": "品牌共建机会",
    "brand_recommender": "品牌推荐官",
    "brand_apply_collab": "品牌申请合作",
    "after_sales_processing": "售后中",
    "after_sales_desc": "售后信息描述",
    "after_sales_info_modal": "售后信息选择弹窗",
    "after_sales_no": "售后单号",
    "after_sales_product_modal": "售后商品选择弹窗",
    "after_sales_button": "售后按钮",
    "after_sales_description": "售后描述",
    "after_sales_desc_input_modal": "售后描述输入弹窗",
    "worry_free_after_sales": "售后无忧",
    "after_sales_status_hint": "售后状态提示",
    "after_sales_reason": "售后理由",
    "after_sales_reason_modal": "售后理由选择弹窗",
    "after_sales_apply_failed": "售后申请失败",
    "after_sales_apply_submitted": "售后申请已提交",
    "after_sales_type": "售后类型",
    "after_sales_detail": "售后详情",
    "after_sales_options": "售后选项",
    "product": "商品",
    "product_info": "商品信息",
    "product_info_incomplete": "商品信息不完整",
    "product_info_area": "商品信息区域",
    "product_info_card": "商品信息卡片",
    "product_info_error": "商品信息异常",
    "product_share_card": "商品分享卡片",
    "product_list": "商品列表",
    "product_card": "商品卡片",
    "product_card_template": "商品卡片模板",
    "product_name": "商品名称",
    "product_image_list": "商品图列表",
    "product_image": "商品图片",
    "product_image_area": "商品图片区域",
    "product_image_carousel": "商品图片轮播",
    "product_basic_info": "商品基本信息",
    "product_off_shelf": "商品已下架",
    "product_invalid": "商品已失效",
    "product_quantity": "商品数量",
    "product_quantity_min": "商品数量不能再少了",
    "product_exposure": "商品曝光",
    "product_tags": "商品标签",
    "product_title": "商品标题",
    "product_grid": "商品网格",
    "product_specs": "商品规格",
    "product_detail": "商品详情",
    "product_amount": "商品金额",
    "merchant": "商家",
    "merchant_name": "商家名称",
    "merchant_invite_user": "商家拉用户",
    "merchant_reject": "商家拒绝",
    "merchant_rejected_after_sales": "商家拒绝了您的售后申请",
    "merchant_rejected_refund": "商家拒绝退款",
    "merchant_no_product_yet": "商家暂未上架商品",
    "merchant_auth": "商家认证",
    "merchant_invited_merchant": "商家邀请的商家",
    "merchant_invited_user": "商家邀请的用户",
    "business": "商户",
    "business_name": "商户名称",
    "business_location": "商户所在地",
    "business_invite_card": "商户邀请卡片",
    "business_territory": "商户领地",
    "sichuan": "四川省",
    "follow_back": "回关",
    "back_to_map": "回到地图",
    "back_to_map_button": "回到地图按钮",
    "back_to_territory": "回到领地",
    "reply": "回复",
    "replied_your_comment": "回复了你的评论",
    "reply_success": "回复成功",
    "reply_comment": "回复评论",
    "reply_input": "回复输入框",
    "callback_failed": "回调函数执行失败",
    "group": "团",
    "group_buy": "团购",
    "group_buy_coupon": "团购券",
    "group_buy_center": "团购券中心",
    "group_buy_product_detail": "团购券商品详情",
    "group_buy_detail": "团购券详情",
    "group_buy_product": "团购商品",
    "group_buy_product_detail_alt": "团购商品详情",
    "group_buy_combo": "团购套餐",
    "group_buy_write_off": "团购核销",
    "group_buy_detail_alt": "团购详情",
    "team_admin": "团队管理员",
    "fixed": "固定",
    "fix_use_first_image": "固定使用第一张图片",
    "fix_at_top": "固定在顶部",
    "fixed_size": "固定宽高",
    "tabbar_home": "领地",
    "tabbar_mall": "商城",
    "tabbar_activity": "活动",
    "tabbar_me": "我的",
    "events_plaza": "活动广场",
    "all_activities": "全部活动",
    "same_city": "同城",
    "hot": "热门",
    "no_activities": "暂无活动",
    "signup_success_msg": "恭喜报名活动成功, 请按时参与活动，可在【我的】-【我的活动】查看详情",
    "search_placeholder_fun": "领地真好玩",


    "fixed_term": "固定期限",
    "icon": "图标",
    "image": "图片",
    "image_upload_area": "图片上传区域",
    "image_load_failed": "图片加载失败",
    "image_area": "图片区域",
    "image_saved_to_album": "图片已保存到相册",
    "image_data_empty": "图片数据为空",
    "image_count_badge": "图片数量标识",
    "image_index_indicator": "图片索引指示器",
    "image_crop_failed": "图片裁剪失败",
    "image_counter": "图片计数器",
    "image_carousel_alt": "图片轮播",
    "arc_progress_bar": "圆弧进度条",
    "ring_chart": "圆环图",
    "rounded_corners": "圆角",
    "tuqi_group_made": "土气集团土气制造",
    "at": "在",
    "online_status": "在线状态",
    "in_territory": "在领地",
    "follow_find_me_in_territory": "在领地关注并找到我",
    "region": "地区",
    "region_selector": "地区选择器",
    "region_picker_modal": "地区选择弹窗",
    "map": "地图",
    "map_load_failed": "地图加载失败",
    "map_container": "地图容器",
    "address_info": "地址信息",
    "modify_address_alt": "地址修改",
    "switch_address_delivery": "地址和配送方式切换",
    "select_address_delivery": "地址和配送方式选择",
    "address_management": "地址管理",
    "address_type": "地址类型",
    "offline_gathering": "场线下聚会",
    "city": "城市",
    "city_list": "城市列表",
    "city_level": "城市级别",
    "base_init_completed": "基础初始化完成",
    "fill_tracking_no": "填写单号",
    "fill_account_info": "填写开户信息",
    "fill_shipping_address": "填写收货地址",
    "fill_id_info": "填写证件信息",
    "fill_return_logistics": "填写退货物流",
    "process": "处理",
    "processing": "处理中",
    "handle_yyb_download": "处理应用宝下载",
    "handle_honor_download": "处理荣耀设备下载",
    "backup": "备",
    "icp_license": "备案号",
    "backup_tag_failed": "备用标签失败",
    "backup_tag_success": "备用标签成功",
    "copy": "复制",
    "copy_usage_comment": "复制使用请保留本段注释",
    "copy_failed": "复制失败",
    "copy_miniapp_link_failed": "复制小程序链接失败",
    "copy_success": "複製成功",
    "copy_invite_code": "复制邀请码",
    "copy_invite_code_failed": "复制邀请码失败",
    "copy_link": "複製連結",
    "copy_territory_link_download": "复制领地链接下载",
    "delivery_available": "外卖可用",
    "foreigner_residence_permit": "外国人居留证",
    "outer_container": "外层容器",
    "outer_container_style": "外层容器控制最大最小高度和背景填充",
    "takeout": "外带",
    "multiple_avatars": "多个头像",
    "greater_than": "大于",
    "lucky_prosperous": "大吉大利",
    "day": "天",
    "valid_within_days": "天内有效",
    "days_ago": "天前",
    "expire_after_days": "天后到期",
    "valid_after_days": "天后有效",
    "daily_checkin": "天天签到",
    "daily_checkin_reward": "天天签到领奖励",
    "day_reward": "天奖励",
    "day_revenue_curve": "天收益曲线",
    "days_count": "天数",
    "days_valid": "天有效",
    "tianjin_city": "天津市",
    "scorpio": "天蝎座",
    "sold_out_in_days": "天被抢光",
    "suncode_load_failed": "太阳码加载失败",
    "suncode_display_area": "太阳码展示区域",
    "suncode_loading": "太阳码未加载完成",
    "invalid": "失效",
    "invalid_product": "失效商品",
    "invalid_status_icon": "失效状态图标",
    "invalid_status_mask": "失效状态遮罩",
    "failed": "失败",
    "avatar": "头像",
    "avatar_info": "头像信息",
    "avatar_stroke": "头像描边",
    "avatar_update_failed": "头像更新失败",
    "avatar_not_loaded": "头像未加载",
    "avatar_frame": "头像框",
    "avatar_frame_display": "头像框展示",
    "avatar_frame_buy_modal": "头像框购买弹窗",
    "avatar_section": "头像部分",
    "header_image_area": "头图区域",
    "header": "头部",
    "header_bg_image": "头部背景图",
    "reward_modal": "奖励弹窗",
    "female": "女",
    "friend_buys_you_earn": "好友买你挣钱",
    "praise": "好评",
    "praise_rank": "好评榜",
    "if_example": "如",
    "submit_gitee_if_suggestion": "如有更好的建议请提交码云",
    "if_need_join_store": "如果你需要入驻门店",
    "if_has": "如果有",
    "if_has_input": "如果有输入内容",
    "if_no_input": "如果没有输入内容",
    "invoice_contact_offline": "如需开据发票请线下联系商铺工作人员",
    "full_name": "姓名",
    "submenu_list": "子菜单列表",
    "font_loading_completed_alt": "字体加载完成",
    "font_loading_mask": "字体加载遮罩",
    "string_format": "字符串格式",
    "full_replace": "完全替代",
    "complete_avatar": "完善头像",
    "complete_account_info": "完善开户信息",
    "complete_shipping_address_hint": "完善您的收货地址",
    "complete_shipping_address": "完善收货地址",
    "completed": "完成",
    "complete_below_actions": "完成下方操作",
    "after_realname_auth": "完成实名认证后",
    "completion_rate": "完成率",
    "full_init_completed": "完整初始化完成",
    "full_modal": "完整弹窗",
    "full_ranking": "完整榜单",
    "official": "官方",
    "official_website": "官方网站",
    "positioning": "定位",
    "positioning_failed": "定位失败",
    "positioning_success": "定位成功",
    "positioning_placeholder": "定位时的占位元素",
    "actual_payment": "实付金额",
    "physical_group_buy_detail": "实体团购详情",
    "physical_retail_detail": "实体零售详情",
    "live_photo": "实况",
    "realname_auth": "实名认证",
    "solid_star": "实心星",
    "realtime_selected_time": "实时显示当前选中的时间",
    "realtime_speed": "实时速度",
    "physical": "实物",
    "physical_coupon": "实物券",
    "physical_goods": "实物商品",
    "physical_group_goods": "实物团购商品",
    "physical_retail_goods": "实物零售商品",
    "implement_pull_refresh_load": "实现下拉刷新和上拉加载",
    "auditing": "审核中",
    "audit_result_notify": "审核结果会以系统消息进行通知",
    "customer_service": "客服",
    "customer_service_card": "客服卡片",
    "family": "家",
    "capacity_select": "容量选择",
    "corresponding_benefits": "对应权益",
    "object_empty": "对象为空",
    "navigation": "导航",
    "nav_position_error": "导航位置错误",
    "nav_failed": "导航失败",
    "navbar": "导航栏",
    "navbar_main": "导航栏主体",
    "navbar_content_area": "导航栏内容区域",
    "will_at": "将于",
    "will_use": "将使用",
    "will_auto_agree_after_sales": "将自动同意售后",
    "will_auto_refund": "将自动退款",
    "will_auto_refund_to_you": "将自动退款给您",
    "small_avatar": "小头像",
    "hour": "小时",
    "ship_within_hours": "小时内发货",
    "hours_ago": "小时前",
    "expire_after_hours": "小时后到期",
    "refund_after_hours": "小时后发起退款",
    "sold_out_in_hours": "小时被抢光",
    "miniapp": "小程序",
    "miniapp_dedicated": "小程序专用",
    "miniapp_code": "小程序码",
    "miniapp_link_empty": "小程序链接为空",
    "miniapp_link_copied": "小程序链接已复制到剪贴板",
    "miniapp_color_extract_failed": "小程序颜色提取失败",
    "miniapp_color_extract_incomplete": "小程序颜色提取暂未完全实现",
    "try_further_batching": "尝试进一步分批",
    "try_downgrade": "尝试降级方案",
    "claim_limited_identity_hint": "就可领取限量领地数字身份",
    "render_open_tag_when_ready": "就绪后渲染开放标签",
    "game_round": "局",
    "local_care": "局部护理",
    "floor_food_court": "层美食城",
    "expand": "展开",
    "expand_collapse_button": "展开收起按钮",
    "expand_more_button": "展开更多按钮",
    "show_bottom_button_placeholder": "展示底部按钮占位",
    "attr_show_search_box": "属性显示搜索框",
    "attr_add_fixed_class_style": "属性添加固定定位类合并后的样式",
    "attr_set_home": "属性设置首页",
    "mountain_chart": "山峰图",
    "left_side": "左侧",
    "left_area": "左侧区域",
    "left_brand_card": "左侧品牌卡",
    "left_product_thumb": "左侧商品缩略图",
    "left_image": "左侧图片",
    "left_avatar": "左侧头像",
    "left_hint_text": "左侧提示文本",
    "left_amount": "左侧金额",
    "left_column": "左列",
    "uploaded_images": "已上传的图片",
    "off_shelf": "已下架",
    "order_generated": "已为您生成交易订单",
    "order_generated_simple": "已为您生成订单",
    "paid": "已付款",
    "used": "已使用",
    "used_status": "已使用状态",
    "followed": "已关注",
    "closed": "已关闭",
    "received_payment": "已到账",
    "added_to_showcase": "已加入橱窗",
    "added_to_cart": "已加入购物车",
    "added_to_selection": "已加入选品库",
    "added_showcase_short": "已加橱窗",
    "all_data_loaded": "已加载全部数据",
    "added_selection_short": "已加选品库",
    "sent_to": "已发送至",
    "cancelled": "已取消",
    "cancelled_remove": "已取消移除",
    "cancelled_top": "已取消置顶",
    "cancelled_default": "已取消默认",
    "sold": "已售",
    "after_sold": "已售后",
    "sold_quantity": "已售数量",
    "already_in": "已在",
    "copied_to_clipboard": "已复制到剪贴板",
    "expired": "已失效",
    "expired_status": "已失效状态",
    "deposited_to_wallet": "已存入钱包",
    "completed_status": "已完成",
    "sale_started": "已开售",
    "store_opened": "已开店",
    "territory_deleted_success": "已成功删除领地",
    "signed_up": "已报名",
    "refused": "已拒收",
    "holding": "已持有",
    "collected": "已揽收",
    "paid_status": "已支付",
    "received_goods": "已收到货",
    "applied_after_sales": "已申请售后",
    "when_logged_in": "已登录时",
    "signed": "已签",
    "signed_for": "已签收",
    "already_hold_digital_goods": "已经持有该数字商品",
    "consecutive_checkin_days": "已经连续签到",
    "settled": "已结算",
    "obtained": "已获得",
    "obtained_avatar_frame": "已获得头像框组件",
    "decoded": "已解码",
    "already_set_as_default": "已设为默认",
    "reminder_set": "已设提醒",
    "share_invoked": "已调起分享",
    "max_upload_limit_reached": "已达到最大上传数量",
    "consecutive_checkin": "已连续签到",
    "refunded": "已退款",
    "already_selected": "已选",
    "selected_region_display": "已选择的地区显示",
    "estimated_commission_from_promotion": "已通过推广商品获得的预估佣金",
    "invited": "已邀请",
    "invited_users": "已邀请的用户",
    "store_closed": "已闭店",
    "read_and_agreed": "已阅读并同意",
    "reserved": "已预约",
    "claimed": "已领取",
    "defaulted": "已默认",
    "city_suffix": "市",
    "layout_error": "布局错误",
    "bring_revenue": "带来收入",
    "with_blur_bg": "带模糊背景",
    "with_white_border": "带白色边框",
    "promoting_sales_volume": "带货销量",
    "with_mask_effect": "带遮罩效果",
    "help_write_station": "帮写充电站",
    "help_promote_brand": "帮助你喜欢的品牌进行推广",
    "common_cities": "常用城市",
    "common_tools": "常用工具",
    "common_is": "常见的是",
    "year": "年",
    "yearly_sales": "年销售额",
    "strict_protection": "并将被严格保护",
    "and_earn_commission": "并赚取佣金",
    "and_claim_reward": "并领取奖励",
    "guangdong_province": "广东省",
    "square": "广场",
    "guangzhou_city": "广州市",
    "serialize_failed": "序列化失败",
    "stock": "库存",
    "lib_replace_self": "库自行替换",
    "yyb_download_failed": "应用宝下载失败",
    "footer_info": "底部信息",
    "footer_info_area": "底部信息区",
    "footer_common": "底部公共部分",
    "footer_area": "底部区域",
    "footer_fixed_profile": "底部固定资料卡",
    "bottom_modal": "底部弹窗",
    "bottom_modal_content": "底部弹窗内容",
    "bottom_button": "底部按钮",
    "bottom_action_button": "底部操作按钮",
    "bottom_action_bar": "底部操作栏",
    "bottom_pay_button": "底部支付按钮",
    "bottom_label_container": "底部标签容器",
    "bottom_gradient_mask": "底部渐变遮罩",
    "bottom_settlement": "底部结算",
    "bottom_settlement_bar": "底部结算栏",
    "bottom_comment_input": "底部评论输入栏",
    "bottom_explain_text": "底部说明文字",
    "bottom_buy_button": "底部购买按钮",
    "shop_available": "店可用",
    "shop_info": "店铺信息",
    "shop_info_order_status": "店铺信息和订单状态",
    "shop_share_card": "店铺分享卡片",
    "shop_share_modal": "店铺分享弹窗",
    "shop_list": "店铺列表",
    "shop_name": "店铺名称",
    "shop_return_rate_high": "店铺回头率超",
    "shop_preparing": "店铺筹备中",
    "shop_home": "店铺首页",
    "enable": "开启",
    "start": "开始",
    "start_minute": "开始分钟",
    "start_init_download": "开始初始化下载",
    "start_loading_fonts": "开始加载字体",
    "start_hour": "开始小时",
    "start_time": "开始时间",
    "account_opened_success": "开户成功",
    "bank_card_number": "开户行卡号",
    "bank_address": "开户行地址",
    "opening_bank": "开户银行",
    "open_for_purchase": "开放购买",
    "open_source_address": "开源地址",
    "opening": "开盘",
    "open_brand_new_stronghold": "开辟你的品牌新据点",
    "open_withdrawable": "开通可提现",
    "open_claim_digital_assets": "开通后可领取数字资产",
    "open_digital_wallet": "开通数字钱包",
    "open_date": "开通日期",
    "guide_content": "引导内容",
    "sheet": "张",
    "coupons_available_count": "张优惠券可用",
    "images_count": "张图片",
    "popup_content": "弹出内容",
    "popup_layer": "弹出层",
    "danmu_track": "弹幕轨道",
    "dialog_box": "弹框",
    "modal": "弹窗",
    "modal_content": "弹窗内容",
    "modal_header": "弹窗头部",
    "when_disabled": "当不启用",
    "current": "当前",
    "current_is_not": "当前为非",
    "current_location": "当前位置",
    "current_balance": "当前余额",
    "balance_insufficient_purchase_hint": "当前余额不足需充值领钻后购买",
    "merchant_invited_by_another": "当前商家被另一个商家邀请",
    "screenshot_not_supported": "当前环境不支持截图功能",
    "bridge_not_supported": "当前环境不支持桥接功能",
    "current_user": "当前登录用户",
    "current_user_tag": "当前登录用户标签",
    "when_enabled": "当启用",
    "pending_payment": "待付款",
    "pending_use": "待使用",
    "pending_ticket": "待出票",
    "pending_seller_delivery": "待卖家交付",
    "pending_seller_accept": "待卖家接单",
    "pending_shipment": "待发货",
    "pending_merchant_confirm": "待商家确认",
    "pending_merchant_confirm_refund_only": "待商家确认且是仅退款",
    "pending_merchant_confirm_return_refund": "待商家确认且是退款退货",
    "pending_merchant_refund": "待商家退款",
    "pending_fill_logistics": "待填写物流信息",
    "pending_audit": "待审核",
    "pending_open_store": "待开店",
    "pending_pickup": "待提货",
    "pending_pay": "待支付",
    "pending_receipt": "待收货",
    "pending_settlement": "待结算",
    "pending_settlement_amount": "待结算金额",
    "pending_evaluation": "待评价",
    "pending_claim": "待领取",
    "very_satisfied": "很满意",
    "regret": "很遗憾",
    "nice_to_meet_everyone": "很高兴认识大家呦",
    "wechat": "微信",
    "wechat_one_click_login": "微信一键登录",
    "wechat_share_thumb": "微信分享缩略图",
    "wechat_share_thumb_component": "微信分享缩略图组件",
    "wechat_friend": "微信好友",
    "miniapp_share_cover_generator": "微信小程序分享卡片封面图生成组件",
    "miniapp_share_thumb": "微信小程序分享缩略图",
    "miniapp_map_not_supported": "微信小程序环境不支持地图显示",
    "wechat_promote": "微信推广",
    "wechat_pay": "微信支付",
    "wechat_env_hint": "微信环境显示提示信息",
    "wechat_login_failed": "微信登录失败",
    "wechat_config_init": "微信配置初始化中",
    "required_param_missing": "必填参数缺失",
    "pizza_hotpot": "必胜打边炉",
    "go_post_memory": "快去发帖纪念一下",
    "go_check_it_out": "快去看看吧",
    "explore_new_world_in_territory": "快去领地探索新世界吧",
    "come_join_territory": "快来加入领地",
    "come_chat_with_me": "快来找我一起聊吧",
    "come_check_it_out": "快来看看吧",
    "express_info_header": "快递信息头部",
    "tracking_number": "快递单号",
    "express_logistics_info": "快递和物流信息",
    "express_order": "快递订单",
    "express_delivery": "快递配送",
    "gender": "性别",
    "gender_age_zodiac_tags": "性别年龄星座等标签",
    "gender_age_tags": "性别年龄标签",
    "total_value": "总价值",
    "total_count": "总计",
    "total_amount": "总金额",
    "congrats": "恭喜",
    "congrats_fortune": "恭喜发财",
    "congrats_you": "恭喜您",
    "congrats_become_nth": "恭喜成为第",
    "congrats_signup_success": "恭喜报名活动成功",
    "congrats_obtain": "恭喜获得",
    "congrats_unlock_achievement": "恭喜解锁首周全勤成就",
    "congrats_first_checkin": "恭喜首签",
    "you_can_repay": "您可重新支付",
    "you_joined_showcase": "您已加入橱窗",
    "you_joined_selection": "您已加入选品库",
    "you_applied_refund": "您已成功发起退款申请",
    "you_revoked_after_sales": "您已撤销售后",
    "you_applied_refund_simple": "您已申请退款",
    "you_passed_territory_auth": "您已通过领地认证",
    "you_currently_have": "您当前有",
    "you_have": "您有",
    "your": "您的",
    "your_referrer_is": "您的上级领航员是",
    "your_info_usage": "您的信息仅为上述用途提供",
    "your_info_protected": "您的信息将严格加密保护",
    "your_account_info_error": "您的开户信息有误",
    "your_led_balance_insufficient": "您的领点余额不足",
    "your_lzd_balance_insufficient": "您的领钻余额不足",
    "you_cannot_withdraw_yet": "您还无法提现",
    "you_not_bind_phone": "您还未绑定手机号",
    "you_selected_too_many_tags": "您选的标签太多啦",
    "surprise_double": "惊喜加倍",
    "surprise_red_packet": "惊喜红包",
    "thanks_support_opensource": "感谢支持开源",
    "become_distributor": "成为分销员",
    "sales_volume_rank": "成交量排名",
    "transaction_amount": "成交金额",
    "success_join_territory": "成功加入一个领地",
    "member_alt": "成员",
    "member_list": "成员列表",
    "member_center": "会员中心",
    "member_center_default_card": "会员卡",
    "member_rights": "会员权益",
    "member_rights_count_suffix": "项权益",
    "member_code": "会员码",
    "member_verification_code": "会员核销码",
    "member_mine": "我的",
    "member_increase": "成员增加",
    "member_action": "成员操作",
    "chengdu_city": "成都市",
    "growth": "成长",
    "growth_value": "成长值",
    "me": "我",
    "i_want_auth": "我也要认证",
    "we_will_auto_register": "我们将自动为您注册",
    "we_need_realname_auth": "我们需要进行实名认证",
    "i_joined": "我加入了",
    "i_joined_adj": "我加入的",
    "i_promoting_in_territory": "我在领地正在帮品牌进行推广",
    "i_hold_digital_assets": "我持有的数字权益资产",
    "i_am": "我是",
    "i_am_here": "我来喽",
    "my": "我的",
    "my_card_pack": "我的卡包",
    "my_qrcode": "我的二维码",
    "my_coupons": "我的优惠券",
    "my_nft": "我的NFT",
    "my_member_points": "我的积分",
    "monthly_exclusive_coupon": "每月专属优惠券",
    "all_discount_offer": "全场8折优惠",
    "points_reward": "积分奖励",
    "exclusive_event": "专属活动",
    "birthday_exclusive_gift": "生日专属礼包",
    "open_membership_now": "立即开通",
    "my_follows": "我的关注",
    "my_moments": "我的动态",
    "my_addresses": "我的地址",
    "my_digital_assets": "我的数字资产",
    "my_tags": "我的标签",
    "my_activities": "我的活动",
    "my_fans": "我的粉丝",
    "my_orders": "我的订单",
    "membership_card_order": "会员卡订单",
    "membership_card_usage_record": "会员卡使用记录",
    "membership_validity": "会员有效期",
    "member_card_points": "会员卡积分",
    "membership_number": "会员编号",
    "my_selection_library": "我的选品库",
    "my_wallet": "我的钱包",
    "nft_digital_asset_order": "NFT数字资产订单",
    "invitation_record": "邀请记录",
    "view_points_detail": "查看积分明细",
    "view_coupon_pack": "查看券包",
    "please_show_qr_to_staff": "请将二维码出示给店员扫描",
    "qr_refresh_after_scan": "每次扫码后二维码将立即更新",
    "qr_auto_refresh": "二维码将在{seconds}秒后自动刷新",
    "other_benefits": "其他权益",
    "purchase_notice": "购买须知",
    "actual_payment": "实付金额",
    "tap_for_details": "点击查看详情",
    "feature_coming_soon": "敬请期待",
    "my_lzd": "我的领钻",
    "i_know": "我知道了",
    "i_want_auth_merchant": "我要认证成为商家",
    "i_invited": "我邀请的",
    "i_earned_a_lot": "我都赚麻",
    "i_earned_a_lot_full": "我都赚麻了",
    "or_buy_via_link": "或分享的链接中购买",
    "or": "或者",
    "screenshot_failed": "截图失败",
    "screenshot_gen_failed": "截图生成失败",
    "screenshot_error": "截图过程中发生未知错误",
    "click_link_get_coupon": "戳链接领优惠",
    "location_place": "所在地",
    "location_region": "所在地区",
    "belong_merchant": "所属商户",
    "all_fonts_loaded_alt": "所有字体加载完成",
    "all_batch_events_passed": "所有批量事件通过",
    "manually_extracted": "手动提取的",
    "manual_parse": "手动解析",
    "manual_decode": "手动解码",
    "manual_trigger_download": "手动触发下载",
    "mobile_number": "手机号",
    "phone_number": "手机号码",
    "only_then_can_send_red_packet": "才可以在地图上发送红包哦",
    "pack_pickup": "打包自提",
    "open": "打开",
    "build_digital_ecology": "打造专属你的数字生态",
    "tax_deduction_rules": "扣税规则",
    "scan": "扫一扫",
    "scan_qrcode": "扫描二维码",
    "scan_button": "扫描按钮",
    "scan_find_me": "扫码进到小程序找到我",
    "batch_send_failed": "批次发送失败",
    "batch_send_exception": "批次发送异常",
    "batch_send_success": "批次发送成功",
    "batch_request_timeout": "批次请求超时",
    "batch": "批量",
    "batch_event_passed": "批量事件通过",
    "batch_add_showcase": "批量加橱窗",
    "batch_send_failed_alt": "批量发送失败",
    "batch_send_exception_alt": "批量发送异常",
    "cabinet_or_station": "投柜或站签收",
    "cabinet_or_station_alt": "投柜或驿站",
    "discount": "折",
    "line_chart": "折线图",
    "grab_red_packet_agree": "抢红包代表同意",
    "rush_buy": "抢购",
    "passport": "护照",
    "signup_info": "报名信息",
    "signup_info_modal": "报名信息弹窗",
    "signup_participate": "报名参与",
    "signup_failed": "报名失败",
    "signup_success": "报名成功",
    "signup_detail": "报名详情",
    "block": "拉黑",
    "block_success": "拉黑成功",
    "reject_reason": "拒绝原因",
    "reject_time": "拒绝时间",
    "access_denied": "拒绝访问",
    "own": "拥有",
    "try_luck": "拼手气",
    "upload_holder_id": "持卡人证件上传",
    "hold": "持有",
    "holder": "持有人",
    "holder_count": "持有人数",
    "after_holding": "持有后",
    "hold_digital_product": "持有数字商品",
    "after_holding_digital_product": "持有数字商品后",
    "hold_digital_asset": "持有数字资产",
    "hold_digital_identity": "持有数字身份",
    "hold_data": "持有数据",
    "held_digital_assets": "持有的数字资产",
    "holder_alt": "持有者",
    "holder_revenue": "持有者收益",
    "hold_territory_identity": "持有领地数字身份",
    "within_designated_period": "指定周期内",
    "by_commission": "按佣金",
    "button": "按钮",
    "button_element_not_found": "按钮元素未找到",
    "button_group_render": "按钮分组渲染",
    "by_sales": "按销量",
    "try_another_network": "换个网络试试",
    "explore_journey_start": "探索之旅正式开启",
    "promotion_alt": "推广",
    "promotion_tool": "推广工具",
    "promotion_record": "推广记录",
    "promote_earn_cash": "推广赚现金",
    "promote_navigator": "推广领航员",
    "recommend": "推荐",
    "recommend_others_buy": "推荐他人购买",
    "recommend_use": "推荐使用",
    "recommend_content_list": "推荐内容列表",
    "recommend_alliance": "推荐联营",
    "recommend_page": "推荐页",
    "recommend_territory": "推荐领地",
    "description_text": "描述文本",
    "description_input_area": "描述输入区域",
    "submit": "提交",
    "submitting": "提交中",
    "audit_after_submit": "提交后会进入到审核阶段",
    "submit_success": "提交成功",
    "submit_button": "提交按钮",
    "upgrade_personal_level": "提升你的个人等级",
    "extract_image_color_failed": "提取图片颜色失败",
    "withdraw": "提现",
    "withdraw_commission": "提现分销佣金",
    "withdraw_success": "提现成功",
    "withdraw_apply": "提现申请",
    "hint": "提示",
    "hint_text": "提示文字",
    "hint_content": "提示文案",
    "hint_page": "提示页",
    "plugin_market_url": "插件市场地址",
    "search": "搜索",
    "search_placeholder": "搜索占位文本",
    "search_history": "搜索历史记录",
    "search_icon": "搜索图标",
    "search_place": "搜索地点",
    "search_shop": "搜索店铺",
    "search_box": "搜索框",
    "search_box_mode": "搜索框模式",
    "search_box_click": "搜索框点击事件",
    "search_input": "搜索输入框",
    "search_territory": "搜索领地",
    "select_territory": "选择领地",
    "please_select_territory": "请选择领地",
    "no_territory_found": "未找到领地",
    "camera_no_permission": "摄像头无权限或无法获取摄像头数据",
    "revoke_after_sales": "撤销售后",
    "revoke_after_sales_failed": "撤销售后失败",
    "revoke_after_sales_success": "撤销售后成功",
    "revoke_time": "撤销时间",
    "operating": "操作中",
    "operation_loading": "操作加载状态",
    "operation_failed": "操作失败",
    "operation_button": "操作按钮",
    "operation_button_area": "操作按钮区域",
    "paying": "支付中",
    "payment_countdown": "支付倒计时",
    "payment_dev_in_progress": "支付功能开发中",
    "after_payment": "支付后",
    "cancel_after_payment": "支付后取消",
    "payment_failed": "支付失败",
    "alipay": "支付宝",
    "alipay_miniapp": "支付宝小程序",
    "payment_modal": "支付弹窗",
    "payment_success": "支付成功",
    "payment_method": "支付方式",
    "payment_method_select": "支付方式选择",
    "payment_serial_no": "支付流水号",
    "payment_result": "支付结果",
    "payment_amount": "支付金额",
    "expenditure": "支出",
    "income_expenditure_detail": "支出和收入明细",
    "support": "支持",
    "support_slot": "支持插槽",
    "recipient": "收件人",
    "recipient_info": "收件人信息",
    "income": "收入",
    "revenue": "收益",
    "revenue_rank": "收益排行榜",
    "revenue_curve": "收益曲线",
    "revenue_tag": "收益标签",
    "revenue_rate": "收益率",
    "close_market": "收盘",
    "collection_total_value": "收藏总价值",
    "receiver": "收货人",
    "receive_place": "收货地",
    "shipping_address": "收货地址",
    "shipping_address_info": "收货地址信息",
    "collapse": "收起",
    "put_store_poster": "放到门店海报",
    "scatter_chart": "散点图",
    "count": "数",
    "digital_product_purchase_notice": "数字产品购买须知",
    "digital_member_card": "数字会员卡",
    "digital_member_promote": "数字会员推广",
    "digital_product": "数字商品",
    "digital_exhibition": "数字展馆",
    "digital_asset_wallet": "数字资产钱包",
    "how_to_buy_digital_assets": "数字权益资产怎么买",
    "what_use_digital_assets": "数字权益资产有什么用",
    "digital_assets_order": "数字权益资产订单",
    "digital_equity_token": "数字权益通证",
    "digital_collection": "数字藏品",
    "digital_asset_equity": "数字资产对应权益",
    "digital_asset_holding": "数字资产持有与沉淀",
    "digital_asset_msg": "数字资产消息",
    "digital_asset_order": "数字资产订单",
    "data": "数据",
    "data_empty": "数据为空",
    "data_load_failed": "数据加载失败",
    "data_format_error": "数据格式错误",
    "data_type_error": "数据类型错误",
    "data_error_exception": "数据错误或程序异常",
    "data_must_be": "数据需为",
    "digital_asset_total_value": "数资总价值",
    "digital_asset_count": "数资数量",
    "file": "文件",
    "file_size_exceed": "文件大小不能超过",
    "file_too_small": "文件太小",
    "file_failed": "文件失败",
    "file_format": "文件格式",
    "new_world": "新世界",
    "newcomer_report": "新人报道",
    "new_product": "新品",
    "new_product_tag": "新品标签",
    "add_shipping_address": "新增收货地址",
    "create_address": "新建地址",
    "novice_navigator": "新手航客",
    "new_retail_detail": "新零售详情",
    "method": "方式",
    "invalid_number": "无效数字",
    "invalid_adj": "无效的",
    "invalid_hex_color": "无效的十六进制颜色值",
    "invalid_sale_time": "无效的开售时间",
    "no_data": "无数据",
    "upload_image_failed": "无法上传图片",
    "create_failed": "无法创建",
    "copy_failed_alt": "无法复制",
    "copy_link_failed": "无法複製連結",
    "login_failed": "无法登录",
    "obtain_failed": "无法获取",
    "obtain_user_info_failed": "无法获取当前用户信息",
    "claim_failed": "无法领取",
    "no_comment_placeholder": "无评论占位",
    "no_threshold": "无门槛",
    "no_need_join_again": "无需重复加入",
    "day_char": "日",
    "calendar": "日历",
    "date": "日期",
    "date_select": "日期选择",
    "date_picker": "日期选择器",
    "old_version": "旧版",
    "times_paradise_walk": "时代天街",
    "display_when": "时显示",
    "timestamp_setting": "时间戳设置",
    "timeline_content": "时间线内容",
    "timeline_icon": "时间线图标",
    "timeline_area": "时间轴区域",
    "timeline_line": "时间轴折线",
    "time_select": "时间选择",
    "time_picker_modal": "时间选择弹窗",
    "tomorrow": "明天",
    "detail_list": "明细列表",
    "star_domain_commander": "星域指挥官",
    "star_domain_overlord": "星域霸主",
    "starbucks": "星巴克",
    "zodiac_tag": "星座标签",
    "save_modified_info_confirm": "是否保存本次修改的信息",
    "delete_address_confirm": "是否删除该地址",
    "enable_follow_reward_confirm": "是否开启关注后领取",
    "delete_account_confirm": "是否注销账号",
    "delete_territory_confirm": "是否确认删除领地",
    "leave_territory_confirm": "是否确认离开领地",
    "auto_focus_confirm": "是否自动获取焦点",
    "logout_confirm": "是否退出登录",
    "nickname": "昵称",
    "after_nickname_birthday": "昵称与生日后",
    "nickname_no_politics": "昵称中请勿含有涉及政治",
    "after_nickname": "昵称后",
    "nickname_and_badge": "昵称和勋章",
    "nickname_and_badge_alt": "昵称和徽章",
    "show_send_button": "显示发送按钮",
    "show_province": "显示省份",
    "show_comment_count": "显示评论总数",
    "show_default_action_button": "显示默认操作按钮",
    "normal": "普通",
    "normal_member": "普通会员",
    "normal_product_card": "普通商品卡片",
    "normal_member_alt": "普通成员",
    "normal_button_bind_success": "普通按钮绑定成功",
    "smart_contract_desc": "智能合约基于贡献自动分账激励协作高效增长",
    "temp_no_revoke": "暂不撤销",
    "temp_not_supported": "暂不支持",
    "temp_no_video_upload": "暂不支持上传视频",
    "temp_no_select": "暂不选择",
    "temp_none": "暂无",
    "temp_no_people_info": "暂无人数信息",
    "temp_no_coupon": "暂无优惠券可用",
    "temp_no_member_card_info": "暂无会员卡信息",
    "temp_no_content": "暂无内容",
    "temp_no_product": "暂无商品",
    "temp_no_address": "暂无地址",
    "temp_no_signup_info": "暂无报名信息",
    "temp_no_revenue": "暂无收益",
    "temp_no_shipping_address": "暂无收货地址",
    "temp_no_data": "暂无数据",
    "temp_no_time_info": "暂无时间信息",
    "temp_no_order": "暂无订单",
    "temp_no_invite_data": "暂无邀请数据",
    "temp_no_invite_record": "暂无邀请记录",
    "temp_no_bank_data": "暂无银行数据",
    "temp_no_store": "暂无门店",
    "temp_no_territory_intro": "暂无领地介绍",
    "temp_no_more": "暂时没有更多了",
    "temp_not_used": "暂未使用",
    "temp_not_joined_store": "暂未入驻门店",
    "more": "更多",
    "more_vouchers": "更多代金券",
    "more_placeholder": "更多占位符",
    "more_rewards": "更多奖励",
    "more_buttons": "更多按钮等",
    "more_powerful": "更强大",
    "change_avatar": "更换头像",
    "change_bank_card": "更换银行卡",
    "lowest": "最低",
    "most": "最多",
    "max_upload": "最多上传",
    "max_send": "最多发送",
    "max_display": "最多展示",
    "final_earn_amount_hint": "最终可赚金额以用户实际结算金额为准",
    "final_interpretation_rights": "最终解释权归平台所有",
    "recent": "最近",
    "recent_search": "最近搜索",
    "highest": "最高",
    "max_earn": "最高可赚",
    "month": "月",
    "monthly_sales": "月售",
    "monthly_sales_volume": "月销",
    "help_merchant_handle_after_sales": "有助于商家更好的处理售后问题",
    "show_when_has_address": "有地址时显示",
    "validity_period": "有效期",
    "validity_type": "有效期类型",
    "validity_type_selector": "有效期类型选择器",
    "valid_until": "有效期至",
    "validity_selection": "有效期选择",
    "service": "服务",
    "service_unavailable": "服务不可用",
    "server_error": "服务器错误",
    "service_not_implemented": "服务未实现",
    "service_tag_and_sales": "服务标签和销量",
    "service_type": "服务类型",
    "service_order": "服务订单",
    "service_fee": "服务费用",
    "chaoyang_district": "朝阳区",
    "uninitialized": "未初始化",
    "dont_give_code_before_arrival": "未到店前请勿将券码提供给商家",
    "location_permission_not_enabled": "未开启定位权限",
    "not_on_sale_but_reserved": "未开售且已预约",
    "not_on_sale_and_not_reserved": "未开售且未预约",
    "minors_cannot_recharge": "未成年人不允许充值",
    "not_found": "未找到",
    "related_bank_not_found": "未找到相关银行",
    "certificate_element_not_found": "未找到证书元素",
    "unauthorized": "未授权",
    "not_received_goods": "未收到货",
    "phone_not_registered_territory": "未注册领地的手机号",
    "not_logged_in": "未登录",
    "unknown": "未知",
    "unknown_merchant": "未知商家",
    "unknown_user": "未知用户",
    "unknown_error": "未知错误",
    "not_obtained": "未获取到",
    "parent_dim_not_obtained": "未获取到父元素宽高尺寸",
    "image_data_not_obtained": "未获得图片数据",
    "nickname_not_set": "未设置昵称",
    "unclaimed_red_packet": "未领取的红包",
    "commission_this_order": "本单佣金",
    "hot_sale_this_week": "本周热卖",
    "hot_this_week": "本周热门",
    "withdraw_amount_this_time": "本次提现金额",
    "rights": "权益",
    "rights_updated_regularly": "权益定期更新",
    "rights_desc": "权益说明",
    "permission_denied": "权限不足",
    "permission_hint": "权限提示",
    "permission_not_enabled": "权限未开启",
    "strip": "条",
    "connections_count": "条人脉",
    "replies_count": "条回复",
    "local_life_videos_count": "条本地生活视频",
    "bar_chart": "条状图",
    "comments_count": "条评论",
    "introduce_your_territory": "来介绍一下你的领地吧",
    "mainland_travel_permit_hkmc": "来往内地通行证",
    "mainland_travel_permit_taiwan": "来往大陆通行证",
    "come_see_my_homepage": "来看看我的主页",
    "from_source": "来自",
    "hangzhou_city": "杭州市",
    "view": "查看",
    "view_personal_homepage": "查看个人主页",
    "view_all": "查看全部",
    "view_coupon_code": "查看券码",
    "view_full_ranking": "查看完整榜单",
    "view_promotion_record": "查看推广记录",
    "view_more": "查看更多",
    "view_more_exciting": "查看更多精彩",
    "view_logistics": "查看物流",
    "view_cash_balance": "查看现金余额",
    "view_order": "查看订单",
    "view_order_status": "查看订单状态",
    "view_detail": "查看详情",
    "view_store": "查看门店",
    "view_territory": "查看领地",
    "column_chart": "柱状图",
    "tag": "标签",
    "tag_and_desc": "标签和描述",
    "tag_row": "标签行",
    "mark_location": "标记地点",
    "title": "标题",
    "title_and_badge_area": "标题和徽章区域",
    "title_and_desc": "标题和说明",
    "title_slot": "标题插槽",
    "title_bar": "标题栏",
    "title_mode": "标题模式",
    "validating": "校验中",
    "validation_failed": "校验失败",
    "validation_passed": "校验通过",
    "according_to": "根据",
    "render_template_by_share_type": "根据分享类型渲染对应模板",
    "compliance_requirements": "根据合规要求",
    "format": "格式",
    "offline_places_like_table_card": "桌卡等线下位置",
    "device_brand_detected": "检测到设备品牌",
    "mode": "模式",
    "mode_not_support_refresh": "模式不支持刷新",
    "after_mode": "模式后",
    "template_injected_at_runtime": "模板内容通过脚本在运行时注入",
    "template_gen_share_cover": "模板方式生成分享封面图",
    "blur_background": "模糊背景",
    "horizontal_scroll_info": "横向滚动信息",
    "horizontal_scroll_image_list": "横向滚动图片列表",
    "showcase": "橱窗",
    "showcase_share_card": "橱窗分享卡片",
    "showcase_card_template": "橱窗卡片模板",
    "showcase_status": "橱窗状态",
    "showcase_bg_image": "橱窗背景图片",
    "showcase_page": "橱窗页面",
    "times": "次",
    "times_recharge": "次充电",
    "refresh_purchase_count_next_day": "次日凌晨刷新购买次数",
    "welcome_to": "欢迎来到",
    "welcome_to_territory": "欢迎来到领地",
    "is_being": "正在",
    "is_downloading": "正在下载",
    "is_loading_more": "正在加载更多",
    "is_loading_bank_list": "正在加载银行列表",
    "is_processing": "正在处理",
    "is_paying": "正在支付",
    "is_chatting": "正在热聊",
    "generating_image": "正在生成图片",
    "generating_poster": "正在生成海报",
    "trigger_business_normal": "正常触发业务",
    "moment_content_by": "此动态文字内容由",
    "phone_used_for_merchant_login": "此手机号将用于登录商家端",
    "step_list": "步骤列表",
    "persistence_pays_off": "毅力初成",
    "each": "每个",
    "limit_per_person": "每人限购",
    "max_earn_per_order": "每单最高可赚",
    "daily_buy_limit_restricted": "每日购买领点次数均有限制",
    "commission_ratio_per_time": "每次获得分销佣金的",
    "drugs_text_info": "毒品的文字信息",
    "ratio": "比例",
    "bubble_content": "气泡内容",
    "bubble_chart": "气泡图",
    "permanent": "永久",
    "accumulate_personal_digital_assets": "沉淀个人数字资产",
    "accumulate_high_quality_relations": "沉淀高质量关系",
    "no_add_to_cart_feature": "没有加入购物车功能",
    "no_more_data": "没有更多数据",
    "no_more_data_text": "没有更多数据了",
    "no_more_data_hint": "没有更多数据提示",
    "no_valid_business_data": "没有有效的业务数据",
    "attention": "注意",
    "delete_account": "注销账号",
    "activity": "活动",
    "activity_people_count": "活动人数",
    "activity_intro": "活动介绍",
    "activity_list": "活动列表",
    "activity_profit_ratio": "活动利润的",
    "activity_location": "活动地点",
    "activity_signup": "活动报名",
    "activity_calendar": "活动日历",
    "activity_time": "活动时间",
    "activity_detail": "活动详情",
    "delivering": "派送中",
    "traffic_content_asset_chain": "流量内容用户资产上链确权沉淀长期价值增长",
    "test": "测试",
    "test_address": "测试地址",
    "zhejiang_province": "浙江省",
    "poster_card_container": "海报卡片容器",
    "poster_modal": "海报弹窗",
    "poster_promote": "海报推广",
    "poster_generating": "海报生成中",
    "haidian_district": "海淀区",
    "message": "消息",
    "message_list": "消息列表",
    "message_red_dot": "消息红点",
    "shenzhen_city": "深圳市",
    "shenzhen_territory_tech": "深圳领地数资科技有限公司",
    "mixed_chart": "混合图",
    "add_follow_failed": "添加关注失败",
    "add_image_button": "添加图片按钮",
    "add_address": "添加地址",
    "add_failed": "添加失败",
    "add_success": "添加成功",
    "bar": "清吧",
    "clear_cart": "清空购物车",
    "clear_search_history": "清除搜索记录",
    "gradient_top": "渐变色顶部",
    "gradient_mask": "渐变遮罩",
    "channel": "渠道",
    "channel_member": "渠道成员",
    "warm_tips": "温馨提示",
    "hkmc_resident_permit": "港澳居民证",
    "render_chart": "渲染图表",
    "render_sub_reply_list": "渲染子回复列表",
    "hunan_province": "湖南省",
    "full": "满",
    "funnel_chart": "漏斗图",
    "activate": "激活",
    "activate_distributor": "激活分销员",
    "activate_distributor_title": "激活分销员标题",
    "waterfall": "瀑布流",
    "waterfall_content": "瀑布流内容",
    "inspiration_burst": "灵感爆棚",
    "lingdie_limited_avatar_frame": "灵蝶物语限定头像框",
    "lingdie_limited_frame_particle": "灵蝶物语限定头像框啦",
    "point": "点",
    "click": "点击",
    "click_upload": "点击上传",
    "click_button_below": "点击下方按钮",
    "click_button_below_view": "点击下方按钮查看",
    "clicked_center_bump": "点击了中间的鼓包",
    "click_to_join_store": "点击入驻",
    "click_go_group_buy": "点击去拼团吧",
    "click_go_look": "点击去看看吧",
    "click_button": "点击按钮",
    "click_view": "点击查看",
    "click_view_moment_detail": "点击查看动态详情",
    "click_view_activity_detail": "点击查看活动详情",
    "click_claim_now": "点击立即领取",
    "click_trigger_business": "点击触发业务逻辑",
    "click_retry": "点击重试",
    "like": "点赞",
    "like_content": "点赞内容",
    "like_success": "点赞成功",
    "like_button": "点赞按钮",
    "like_count": "点赞数",
    "like_data": "点赞数据",
    "like_message": "点赞消息",
    "like_comment": "点赞评论",
    "calendar_remind_time": "点进行日历提醒",
    "hot_sales_ranking": "热卖排行榜",
    "hot_sales_rank": "热卖榜",
    "hot_sales": "热销",
    "hot_products": "热门商品",
    "hot_merchants": "热门商家",
    "hot_rank": "热门榜",
    "best_selling": "爆款畅销",
    "parent_menu": "父级菜单",
    "version": "版本",
    "version_not_supported": "版本不受支持",
    "version_no": "版本号",
    "version_suffix": "版本后",
    "logistics": "物流",
    "logistics_info": "物流信息",
    "logistics_company": "物流公司",
    "logistics_company_modal": "物流公司选择弹窗",
    "logistics_timeline": "物流时间线",
    "logistics_fast": "物流超快",
    "featured_tag": "特色标签",
    "status_tab": "状态标签页",
    "status_bar_placeholder": "状态栏占位区域",
    "status_code": "状态码",
    "exclusive_debut": "独家首发",
    "cat_dog_general": "猫咪狗狗通用",
    "return_of_king": "王者归来",
    "gameplay_rules": "玩法说明",
    "rose_chart": "玫瑰图",
    "environment": "环境",
    "cash_balance": "现金余额",
    "reason_alt": "理由",
    "luckin_coffee": "瑞幸咖啡小蓝杯",
    "bottle_beer": "瓶啤酒",
    "generate": "生成",
    "generate_qrcode_failed": "生成二维码失败",
    "generate_share_image": "生成分享图片",
    "generate_share_cover": "生成分享封面图",
    "generate_image_timeout": "生成图片超时",
    "generate_suncode_failed": "生成太阳码失败",
    "generate_miniapp_link_failed": "生成小程序链接失败",
    "generate_promote_fingerprint_failed": "生成推广指纹码失败",
    "generate_poster": "生成海报",
    "generating_poster_status": "生成海报中",
    "generating_certificate": "生成证书中",
    "generate_link_failed": "生成链接失败",
    "birthday": "生日",
    "use_prep": "用",
    "used_for_screenshot": "用于截图",
    "used_for_pregen_share_cover": "用于预生成分享封面图",
    "user": "用户",
    "user_homepage": "用户主页",
    "user_homepage_card_template": "用户主页卡片模板",
    "user_info": "用户信息",
    "user_info_content": "用户信息内容",
    "user_info_loading": "用户信息載入中",
    "user_info_section": "用户信息区",
    "user_info_area": "用户信息区域",
    "user_info_card": "用户信息卡片",
    "user_info_row": "用户信息行",
    "user_followed_you": "用户关注了你",
    "user_share_card": "用户分享卡片",
    "user_list": "用户列表",
    "user_moment_card": "用户动态卡片",
    "user_medal": "用户勋章",
    "user_agreement": "用户协议",
    "username_and_avatar": "用户名和头像",
    "user_avatar": "用户头像",
    "user_avatar_as_bg": "用户头像作为背景",
    "user_avatar_list": "用户头像列表",
    "after_user_scan": "用户扫码后",
    "user_invite_merchant": "用户拉商家",
    "user_nickname": "用户昵称",
    "user_not_login": "用户未登录",
    "user_level": "用户等级",
    "user_red_packet_protocol": "用户红包奖励协议",
    "user_contribution": "用户贡献",
    "user_logout": "用户退出",
    "user_privacy_policy": "用户隐私协议",
    "apply_create_territory": "申请创建领地",
    "apply_collaboration": "申请合作",
    "apply_after_sales": "申请售后",
    "after_apply_audit_passed": "申请审核通过后",
    "apply_time": "申请时间",
    "apply_refund": "申请退款",
    "phone": "电话",
    "phone_number_error": "电话号码错误",
    "male": "男",
    "canvas": "画布",
    "speak_freely": "畅所欲言",
    "speak_freely_system_upgrade": "畅所欲言系统已全面升级",
    "login": "登录",
    "logging_in": "登录中",
    "after_login": "登录后",
    "login_failed_alt": "登录失败",
    "login_expired": "登录已过期",
    "login_success": "登录成功",
    "login_phone": "登录手机号",
    "auto_register_at_login": "登录时将自己注册",
    "login_form_area": "登录表单区域",
    "white_background": "白色背景",
    "white_bg_card": "白色背景卡片",
    "white_transparent_mask": "白色透明遮罩",
    "white_clam_butterfly": "白蚬蝶",
    "silver_navigator": "白银领航员",
    "percentage": "百分比",
    "of_de": "的",
    "of_follow": "的关注",
    "of_group_buy": "的团购",
    "of_processing": "的处理",
    "of_recommend": "的推荐",
    "of_showcase": "的橱窗",
    "of_fans": "的粉丝",
    "of_drawing_context": "的绘图上下文并传入",
    "blind_box_product_name": "盲盒商品名称",
    "blind_box_product_image": "盲盒商品图",
    "direct_download": "直接下载",
    "live_streaming": "直播中",
    "related_recommend": "相关推荐",
    "equivalent_to": "相当于",
    "province_list": "省份列表",
    "province_level": "省份级别",
    "real_name": "真实姓名",
    "known_it": "知道了",
    "confirm": "确定",
    "confirm_delete": "确定删除",
    "confirm_equip": "确定装扮",
    "confirm_delete_moment": "确定要删除动态吗",
    "confirm_clear_cart": "确定要删除购物车中所有商品",
    "confirm_unfollow": "确定要取消关注吗",
    "confirm_cancel_order": "确定要取消订单吗",
    "confirm_revoke_after_sales": "确定要撤销本次申请售后吗",
    "confirm_buy": "确定要购买",
    "confirm_alt": "确认",
    "confirm_cancel_payment": "确认取消支付吗",
    "confirm_revoke": "确认撤销",
    "confirm_pay": "确认支付",
    "confirm_pay_button": "确认支付按钮",
    "confirm_receipt": "确认收货",
    "after_confirm_receipt": "确认收货后",
    "confirm_receipt_success": "确认收货成功",
    "confirm_clear_search_history": "确认清除所有搜索记录吗",
    "confirm_order": "确认订单",
    "gift": "礼物",
    "blessing": "祝福语",
    "leave_territory": "离开领地",
    "private_domain_fission": "私域裂变",
    "qiuyun": "秋云",
    "qiuyun_charts": "秋云高性能跨全端图表组件",
    "share_type_kinds": "种分享类型",
    "seconds": "秒",
    "expire_in_seconds": "秒到期",
    "seconds_video": "秒的视频",
    "sold_out_in_seconds": "秒被抢光",
    "points": "积分",
    "points_module": "积分模块",
    "operate_remove_in_detail": "移除功能请在详情页操作",
    "remove_success": "移除成功",
    "remove_channel": "移除频道",
    "rare": "稀有",
    "hollow_star": "空心星",
    "empty_data_state": "空数据状态",
    "empty_state": "空状态",
    "recharge_now": "立即充值",
    "open_now": "立即开启",
    "own_now": "立即拥有",
    "view_now": "立即查看",
    "activate_digital_product_now": "立即激活您的数字商品",
    "checkin_now": "立即签到",
    "verify_now": "立即认证",
    "buy_now": "立即购买",
    "book_now": "立即预约",
    "claim_now": "立即领取",
    "placeholder_pos": "站位",
    "symbol": "符号",
    "rank_prefix": "第",
    "step_one": "第一步",
    "received_next_day": "第二天就收到了",
    "step_two": "第二步",
    "etc": "等",
    "level_list": "等级列表",
    "level_upgrade": "等级升级",
    "higher_level": "等级越高",
    "spec_options_available": "等规格可选",
    "filter_button": "筛选按钮",
    "filter_tag": "筛选标签",
    "filter_bar": "筛选栏",
    "filter_mask": "筛选遮罩层",
    "checkin_days": "签到天数",
    "checkin_success": "签到成功",
    "checkin_remind": "签到提醒",
    "checkin_remind_on": "签到提醒已开启",
    "checkin_calendar": "签到日历",
    "checkin_grid": "签到格子",
    "checkin_rank": "签到第",
    "signature_alt": "签名",
    "signature_no_politics": "签名中请勿含有涉及政治",
    "signature_param_incomplete": "签名参数不完整",
    "sign_distributor_contract": "签署分销合同",
    "management": "管理",
    "admin": "管理员",
    "meter": "米",
    "type": "类型",
    "type_incorrect": "类型不正确",
    "type_will_be_at": "类型会在",
    "fans": "粉丝",
    "fans_count_etc": "粉丝和关注等数量",
    "yue_province": "粤",
    "series": "系列",
    "series_count": "系列个数",
    "series_product": "系列商品",
    "system": "系统",
    "system_message": "系统消息",
    "purple_background": "紫色背景",
    "accumulate_led": "累计得领点",
    "accumulate_lzd": "累计得领钻",
    "accumulate_revenue": "累计收益",
    "accumulate_revenue_amount": "累计收益金额",
    "accumulate_obtain": "累计获得",
    "accumulate_earn_commission": "累计赚佣",
    "accumulate_invite": "累计邀请",
    "accumulate_invite_count": "累计邀请人数",
    "red_packet": "红包",
    "red_packet_count": "红包个数",
    "red_packet_count_limit": "红包个数不可以超过",
    "red_packet_share_card": "红包分享卡片",
    "level_distributor": "级分销员",
    "level_territory": "级领地",
    "line_chart_alt": "线图",
    "component_gen_qrcode": "组件自己负责二维码生成",
    "combined_use": "组合使用",
    "bind_success": "绑定成功",
    "bind_phone": "绑定手机号",
    "bind_time": "绑定时间",
    "bind_invite_code": "绑定邀请码",
    "bind_bank_card": "绑定银行卡",
    "end": "结束",
    "end_minute": "结束分钟",
    "end_hour": "结束小时",
    "end_time": "结束时间",
    "settling": "结算中",
    "settlement_record": "结算记录",
    "draw_avatar_failed": "绘制头像失败",
    "bring_to_holder": "给持有者带来",
    "stats_data": "统计数据",
    "continue_open": "继续开启",
    "continue_pay": "继续支付",
    "green_dot": "绿点",
    "removed_at_compile": "编译阶段移除",
    "edit_address": "编辑地址",
    "edit_shipping_address": "编辑收货地址",
    "missing": "缺",
    "network_upload_failed": "网络上传失败",
    "network_timeout": "网络超时",
    "network_connect_failed": "网络连接失败",
    "network_error": "网络错误",
    "pin_top": "置顶",
    "pinned_message": "置顶了消息",
    "operate_pin_in_detail": "置顶功能请在详情页操作",
    "pin_success": "置顶成功",
    "pin_comment": "置顶评论",
    "but_is": "而是",
    "contact_support": "联系客服",
    "contact_phone": "联系电话",
    "alliance": "联营",
    "alliance_price": "联营价",
    "alliance_showcase": "联营橱窗",
    "alliance_is_good": "联营真好啊",
    "alliance_self_buy_price": "联营自购价",
    "background": "背景",
    "background_image": "背景图",
    "background_image_alt": "背景图片",
    "victory_in_sight": "胜利在望",
    "auto_join_your_territory": "自动加入你的领地",
    "auto_login_failed": "自动登录失败",
    "customize": "自定义",
    "custom_loading_state": "自定义加载状态",
    "custom_legend": "自定义图例",
    "custom_image_preview": "自定义图片预览",
    "custom_navbar": "自定义导航栏",
    "custom_indicator": "自定义指示器",
    "custom_time": "自定义时间",
    "custom_type": "自定义类型",
    "custom_error_hint": "自定义错误提示",
    "self_earn_commission_reward": "自己也会获得的对应佣金奖励",
    "pickup": "自提",
    "pickup_time_select": "自提时间选择",
    "pickup_code": "自提码",
    "self_buy_save_money": "自购省钱",
    "to_range": "至",
    "porn": "色情",
    "node": "节点",
    "node_get_failed": "节点获取失败",
    "if_problem_not_solved": "若您的问题尚未解决",
    "if_phone_not_registered": "若该手机号未注册",
    "if_need_recharge_invoice": "若需要充值发票",
    "honor_market_open_failed": "荣耀市场打开失败",
    "honor_market_timeout": "荣耀市场超时",
    "obtain": "获取",
    "obtain_location_failed": "获取位置失败",
    "obtain_location_permission_failed": "获取位置权限失败",
    "obtain_share_domain_failed": "获取分享域名失败",
    "obtain_dynamic_param_error": "获取动态参数错误",
    "obtain_district_data_failed": "获取区县数据失败",
    "obtain_after_sales_reason_failed": "获取售后理由失败",
    "obtain_image_data_failed": "获取图像数据失败",
    "obtain_city_data_failed": "获取城市数据失败",
    "obtain_suncode_failed": "获取太阳码失败",
    "obtain_phone_failed": "获取手机号失败",
    "obtain_data_failed": "获取数据失败",
    "obtain_time": "获取时间",
    "obtain_detail": "获取明细",
    "failed_to_obtain_user_information": "获取用户信息失败",
    "obtained_of": "获取的",
    "obtain_street_data_failed": "获取街道数据失败",
    "obtain_bank_list_failed": "获取银行列表失败",
    "obtain_navigator_id": "获取领航员数字身份",
    "obtain_verify_code": "获取验证码",
    "obtain_profit_share": "获得分润",
    "obtain_higher_commission": "获得更高佣金",
    "got_liked": "获赞",
    "caidekuai": "菜得快",
    "caidekuai_dish": "菜得快现炒尖椒蛙拌面",
    "feige": "菲鸽",
    "business_open": "营业中",
    "business_license": "营业执照",
    "business_hours": "营业时间",
    "business_hours_picker": "营业时间选择器弹窗",
    "business_status_time": "营业状态和时间",
    "collection": "藏品",
    "collection_name": "藏品名称",
    "collection_hash": "藏品哈希值",
    "collection_total_value_alt": "藏品总价值",
    "collection_story": "藏品故事",
    "collection_certificate": "藏品证书",
    "xietta": "蟹太太",
    "row": "行",
    "row_auto_scroll": "行自动无缝上滑",
    "street_list": "街道列表",
    "street_level": "街道级别",
    "supplementary_desc": "补充描述",
    "awakened": "被唤醒",
    "liked_passive": "被点赞",
    "decoration_package": "装饰包裹",
    "xicheng_district": "西城区",
    "spec_select": "规格选择",
    "spec_select_component": "规格选择组件",
    "spec_options": "规格选项",
    "video_upload_timeout": "视频上传超时",
    "video_no_face": "视频中无有效人脸",
    "video_content": "视频内容",
    "video_area": "视频区域",
    "video_play_icon": "视频播放图标",
    "video_format_invalid": "视频格式不满足要求",
    "video_detail": "视频详情",
    "badge_display": "角标显示",
    "solve_problems_fast": "解决问题快",
    "parse": "解析",
    "parse_upload_response_failed": "解析上传响应失败",
    "parse_response_failed": "解析响应失败",
    "unlock_exclusive_rights": "解锁专属权益",
    "unlock_merchant_privilege_digit": "解锁商家联营特权与限量数字",
    "unlock_merchant_privilege_collection": "解锁商家联营特权与限量数字藏品",
    "trigger_wechat_phone_login": "触发微信获取手机号登录",
    "trigger_button": "触发按钮",
    "order_info": "订单信息",
    "order_list": "订单列表",
    "order_list_content": "订单列表内容",
    "order_no_not_exist": "订单号不存在",
    "order_remark": "订单备注",
    "order_total_and_action": "订单总价和操作",
    "order_total_amount": "订单总金额",
    "order_payment": "订单支付",
    "order_count": "订单数",
    "order_number": "订单编号",
    "order_detail": "订单详情",
    "order_amount": "订单金额",
    "auth_and_digital_assets": "认证以及数字资产",
    "auth_info_error": "认证信息有误",
    "auth_failed": "认证失败",
    "auth_success": "认证成功",
    "after_auth_success": "认证成功后",
    "auth_type": "认证类型",
    "auth_desc": "认证说明",
    "make_you_prettiest_boy": "让你成为最靓的仔",
    "set_as_default": "设为默认",
    "set_as_default_shipping_address": "设为默认收货地址",
    "device_download": "设备下载",
    "settings": "设置",
    "set_as_member": "设置为成员",
    "set_success": "设置成功",
    "set_admin": "设置管理员",
    "design_draft": "设计稿",
    "certificate_content_area": "证书内容区域",
    "id_card_portrait_side": "证件人像面",
    "id_card_number": "证件号码",
    "id_card_national_emblem_side": "证件国徽面",
    "id_card_validity_type": "证件有效期类型",
    "id_card_type": "证件类型",
    "evaluate": "评价",
    "score": "评分",
    "score_number": "评分数字",
    "score_star": "评分星星",
    "score_row": "评分行",
    "comment": "评论",
    "comment_and_reply": "评论与回复",
    "commented_your_moment": "评论了你的动态",
    "comment_content": "评论内容",
    "comment_list_scroll_container": "评论列表滚动容器",
    "comment_area": "评论区",
    "comment_deleted": "评论已删除",
    "comment_button": "评论按钮",
    "comment_action": "评论操作",
    "comment_count": "评论数",
    "comment_body": "评论正文",
    "comment_user_avatar": "评论用户头像",
    "recognize": "识别",
    "recognize_failed": "识别失败",
    "recognize_success": "识别成功",
    "word_cloud_chart": "词云图",
    "product_not_in_selection_library": "该商品暂未加入你的选品库",
    "user_account_cancelled": "该用户已注销",
    "spec_out_of_stock": "该规格暂无库存",
    "territory_deleted": "该领地已删除",
    "detail": "详情",
    "detailed_address": "详细地址",
    "detailed_address_info": "详细地址信息",
    "say_something": "说点什么",
    "please_upload_id_card": "请上传身份证件图片",
    "please_scroll_read_protocol": "请下滑阅读协议后继续",
    "please_download": "请下载",
    "please_download_amap": "请下载高德地图",
    "please_use": "请使用",
    "please_use_app_or_miniapp": "请使用原生应用或小程序",
    "please_recharge_and_retry": "请充值后再次重试",
    "please_upload_back_image_first": "请先上传反面图片",
    "please_upload_image_first": "请先上传图片",
    "please_negotiate_with_merchant_first": "请先与商家协商一致",
    "please_complete_real_name_auth_first": "请先完成实名认证",
    "please_login_first": "请先登录",
    "please_check_in_personal_wallet": "请到个人钱包查看",
    "please_update_app_version": "请到应用市场更新最新版本进行正常使用",
    "please_open_in_wechat": "请到微信内打开链接",
    "please_go_to_settings_enable": "请前往设置开启",
    "dont_believe_brushing": "请勿轻信刷单",
    "please_consult_territory": "请咨询领地",
    "please_select_location_in_list": "请在下方列表中选择位置",
    "please_pay_in_wechat_browser": "请在微信浏览器支付",
    "please_enable_calendar_permission_in_settings": "请在设置中开启日历权限",
    "please_enable_permission_in_settings": "请在设置中开启权限",
    "please_fill_address": "请填写地址",
    "please_fill_name": "请填写姓名",
    "please_fill_phone": "请填写手机号",
    "please_fill_detailed_address": "请填写详细地址",
    "please_wait_patiently": "请您耐心等待",
    "please_fill_manually": "请手动填写",
    "please_open_location_permission": "请打开位置权限",
    "please_participate_on_time": "请按时参与活动",
    "please_change_here": "请改这里",
    "please_check_and_resubmit": "请检查后重新提交",
    "please_check_permission": "请检查权限",
    "please_check_network": "请检查网络",
    "please_check_network_retry": "请检查网络后重试",
    "please_check_network_or_contact_admin": "请检查网络或联系管理员",
    "please_check_network_or_config": "请检查网络或配置",
    "please_check_network_connection": "请检查网络连接",
    "request_error": "请求出错",
    "request_send_failed": "请求发送失败",
    "request_send_exception": "请求发送异常",
    "request_send_success": "请求发送成功",
    "request_timeout": "请求超时",
    "invalid_request": "请求错误",
    "please_note_traffic": "请注意流量",
    "please_click": "请点击",
    "please_click_button_operate": "请点击下方按钮进行操作",
    "please_click_retry": "请点击重试",
    "please_retry_later": "请稍后重试",
    "please_wait": "请稍等",
    "please_bind_view_message": "请绑定后查看消息",
    "please_wait_patiently_alt": "请耐心等待",
    "please_wait_merchant_process": "请耐心等待商家处理",
    "please_keep_at_least_one_product": "请至少保留一个商品",
    "please_retry_after_purchase": "请购买后再次重试",
    "please_input": "请输入",
    "please_input_content": "请输入内容",
    "please_input_merchant_name": "请输入商户名称",
    "please_input_name": "请输入姓名",
    "please_input_bank_card_no": "请输入开户行卡号",
    "please_input_bank_name": "请输入开户行名称",
    "please_input_tracking_no": "请输入快递单号",
    "please_input_nickname": "请输入您的昵称",
    "please_input_real_name": "请输入您的真实姓名",
    "please_input_signature": "请输入您的签名",
    "please_input_phone": "请输入手机号",
    "please_input_holder_address": "请输入持证人详细地址",
    "please_input_withdraw_amount": "请输入提现金额",
    "please_input_search_content": "请输入搜索内容",
    "please_input_correct_info": "请输入正确信息",
    "please_input_correct_phone": "请输入正确的手机号",
    "please_input_real_name_alt": "请输入真实姓名",
    "please_input_auth_desc": "请输入认证说明",
    "please_input_id_card_no": "请输入证件号码",
    "please_input_detailed_address": "请输入详细地址",
    "please_input_id_number": "请输入身份证号",
    "please_input_invite_code": "请输入邀请码",
    "please_input_bank_phone": "请输入银行预留手机号",
    "please_input_store_name": "请输入门店名称",
    "please_input_store_phone": "请输入门店电话",
    "please_input_store_manager": "请输入门店负责人",
    "please_input_reserved_phone": "请输入预留手机号",
    "please_input_verify_code": "请输入验证码",
    "please_return_home_buy": "请返回个人主页购买",
    "please_select": "请选择",
    "please_select_payment_method": "请选择付款方式",
    "please_select_send_location": "请选择发送位置",
    "please_select_pickup_time": "请选择取货时间",
    "please_select_after_sales_product": "请选择可售后的商品",
    "please_select_product": "请选择商品",
    "please_select_merchant_location": "请选择商户所在地",
    "please_select_region": "请选择地区",
    "please_select_city": "请选择城市",
    "please_select_complete_address": "请选择完整的地址信息",
    "please_select_start_time": "请选择开始时间",
    "please_select_bank_address": "请选择开户行地址",
    "please_select_bank_province": "请选择开户行所在省",
    "please_select_bank": "请选择开户银行",
    "please_select_delete_product": "请选择想要删除的商品",
    "please_select_holder_id_type": "请选择持证人证件类型",
    "please_select_shipping_address": "请选择收货地址",
    "please_select_time": "请选择时间",
    "please_select_validity_type": "请选择有效期类型",
    "please_select_logistics_company": "请选择物流公司",
    "please_select_pcd_street": "请选择省市区街道",
    "please_select_end_time": "请选择结束时间",
    "please_select_bg_image": "请选择背景图",
    "please_select_business_hours": "请选择营业时间",
    "please_select_spec": "请选择规格",
    "please_select_id_validity_start": "请选择证件有效期开始时间",
    "please_select_id_validity_type": "请选择证件有效期类型",
    "please_select_id_validity_end": "请选择证件有效期结束时间",
    "please_select_buy_option": "请选择购买选项",
    "please_select_store_type": "请选择门店业态",
    "please_select_store_location": "请选择门店位置",
    "please_relogin": "请重新登录",
    "please_retry": "请重试",
    "please_long_press_save": "请长按图片保存",
    "please_read_and_agree": "请阅读并同意",
    "please_read_and_agree_protocol": "请阅读并同意已下协议",
    "call_failed": "调用失败",
    "call_success": "调用成功",
    "invoke_payment_method": "调起支付方式",
    "beware_scams": "谨防上当受骗",
    "manager_info": "负责人信息",
    "contribution_value": "贡献值",
    "contribution_detail": "贡献值详情",
    "contribution_is_ownership": "贡献即确权",
    "bill": "账单",
    "account_balance_insufficient": "账户可用余额不足",
    "goods_status": "货物状态",
    "goods_status_modal": "货物状态选择弹窗",
    "buy": "购买",
    "buy_my_shared_product": "购买了我分享的商品",
    "buy_feature_developing": "购买功能开发中",
    "after_buy": "购买后",
    "buy_only_support_use": "购买后仅支持使用",
    "auto_equip_frame_after_buy": "购买后自动佩戴此头像框",
    "buy_product_exception": "购买商品异常时",
    "buy_avatar_frame": "购买头像框",
    "buy_success": "购买成功",
    "buy_specified_product_claim": "购买指定商品即可领取",
    "buy_button": "购买按钮",
    "buy_digital_rights_join_territory": "购买数字权益资产并加入领地",
    "buy_digital_asset_auth_limit": "购买数字资产以及激活分销员权限需完成实名认证",
    "buy_digital_asset": "购买数资",
    "buy_digital_rights_get_tasks": "购买此数字权益资产后可完成以下任务",
    "buy_digital_rights_get_distribution": "购买此数字权益资产后可获得以下商品分销权",
    "buy_digital_rights_get_rights": "购买此数字权益资产后可获得以下权益",
    "buy_confirm": "购买确认",
    "buy_options": "购买选项",
    "purchase_notes": "购买须知",
    "buy_ling_point": "购买领点",
    "buy_navigator": "购买领航员",
    "shopping_coupon": "购物券",
    "shopping_cart": "购物车",
    "cart_empty": "购物车为空",
    "cart_modal": "购物车弹窗",
    "assets": "资产",
    "asset_authentication": "资产确权",
    "profile_update_failed": "资料修改失败",
    "profile_update_success": "资料修改成功",
    "after_profile_complete": "资料全部完善后",
    "profile_completion": "资料完成度",
    "resource_ability_monetization": "资源与能力自由变现",
    "resource_ability_digitization": "资源能力数字化",
    "qualification_info": "资质信息",
    "empower_individual": "赋能个人",
    "earn": "赚",
    "earned": "赚了",
    "earn_more_rewards": "赚取更多奖励",
    "thumbs_up": "赞",
    "liked_your_moment": "赞了你的动态",
    "liked_your_comment": "赞了你的评论",
    "people_who_liked": "赞过的人",
    "people_who_liked_modal": "赞过的人弹框",
    "gift_item": "赠品",
    "gift_amount": "赠送款",
    "gift_white_clam_message": "赠送白蚬蝶数字资产消息",
    "from_price": "起",
    "super_value_price": "超值价",
    "super_value_coupon": "超值优惠券",
    "timeout_unpaid": "超时未支付",
    "distance_from_you": "距你",
    "distance_from_you_honor": "距您",
    "distance_greater_than": "距您大于",
    "distance": "距离",
    "distance_filter_item": "距离区域筛选项",
    "follow_buy_count": "跟买人数",
    "follow_buy_count_tag": "跟买人数标签",
    "follow_gesture": "跟随手势",
    "jump_failed": "跳转失败",
    "identity_info_error": "身份信息有误",
    "identity_mark": "身份标识",
    "id_card": "身份证",
    "id_card_upload": "身份证上传",
    "id_document_upload": "身份证件上传",
    "id_document_image": "身份证件图片",
    "id_info": "身份证信息",
    "id_info_form": "身份证信息表单",
    "id_number": "身份证号",
    "id_card_photos": "身份证正反面照片",
    "after_transform": "转换后",
    "manage_community_easily": "轻松运营你的社群",
    "glory_peak_arrival": "辉煌的顶峰即将抵达",
    "input_must_be_number": "输入必须为数字",
    "input_phone": "输入手机号",
    "input_sms_user_pass": "输入短信中的用户名与密码",
    "input_id_info": "输入证件信息",
    "input_amount_exceed_balance": "输入金额超出可提现金额",
    "input_verify_code": "输入验证码",
    "influencer_recommending": "达人在推荐",
    "influencer_recommend": "达人推荐",
    "refund_if_expired": "过期退",
    "freight": "运费",
    "freight_coupon": "运费券",
    "transporting": "运输中",
    "transport_status_card": "运输状态卡片",
    "back": "返回",
    "return_data_format_error": "返回数据格式错误",
    "back_home": "返回首页",
    "no_one_commented_yet": "还没有人发表过评论",
    "this_guy_is_lazy": "这家伙很懒",
    "this_is_active_interaction": "这是一个通过积极互动",
    "symbol_of_identity_status": "这是你在社区中身份与地位的象征",
    "here_is_barren": "这里一片荒芜",
    "enter_homepage": "进入主页",
    "enter_homepage_arrow": "进入主页箭头",
    "enter_territory": "进入领地",
    "enter_shop": "进店",
    "enter_shop_button": "进店按钮",
    "visit_shop": "进店逛逛",
    "progress_indicator": "进度指示器",
    "perform_operation": "进行操作",
    "manage_store": "进行门店管理",
    "connection_error": "连接出错",
    "connection_line": "连接线",
    "logout_alt": "退出登录",
    "return_back": "退回",
    "refund": "退款",
    "refunding": "退款中",
    "refund_info": "退款信息",
    "refund_product_info": "退款商品信息",
    "refund_failed": "退款失败",
    "refund_closed": "退款已关闭",
    "refund_success": "退款成功",
    "refund_no_fee": "退款无需支付手续费",
    "refund_time": "退款时间",
    "refund_reason": "退款理由",
    "refund_reason_modal": "退款理由弹窗",
    "refund_apply_failed": "退款申请失败",
    "refund_apply_submitted": "退款申请已提交",
    "refund_progress": "退款进度",
    "refund_amount": "退款金额",
    "return_refund": "退货退款",
    "exclusive_rights_for_you": "送给你的专属权益",
    "applicable_shop": "适用店铺",
    "applicable_store": "适用门店",
    "adapt_notch_screen": "适配刘海屏",
    "selection_square": "选品广场",
    "selection_library": "选品库",
    "selection_cart": "选品车",
    "optional_field": "选填",
    "selection_done": "选好了",
    "select": "选择",
    "select_coupon": "选择优惠券",
    "select_location_failed": "选择位置失败",
    "select_birth_date": "选择出生日期",
    "select_after_sales_info": "选择售后信息",
    "select_after_sales_reason": "选择售后原因",
    "select_after_sales_product": "选择售后商品",
    "select_after_sales_reason_alt": "选择售后理由",
    "select_product": "选择商品",
    "select_product_image": "选择商品图片",
    "select_merchant": "选择商家",
    "select_image_failed": "选择图片失败",
    "select_region": "选择地区",
    "select_city": "选择城市",
    "select_start_time": "选择开始时间",
    "select_bank_address": "选择开户行地址",
    "select_gender": "选择性别",
    "select_shipping_address": "选择收货地址",
    "select_date": "选择日期",
    "select_validity_type": "选择有效期类型",
    "select_status": "选择状态",
    "select_end_time": "选择结束时间",
    "select_goods_status": "选择货物状态",
    "select_bank_card": "选择银行卡",
    "select_store_type": "选择门店业态",
    "select_territory_bg": "选择领地背景",
    "select_territory_bg_image": "选择领地背景图",
    "transparent": "透明",
    "transparent_mask": "透明蒙层",
    "usually_an_image": "通常是一个图片",
    "via_nft_issue_community": "通过数字藏品发行与社群运营",
    "traverse_comment_list": "遍历评论列表",
    "mask_layer": "遮罩层",
    "avoid_being": "避免被",
    "invite": "邀请",
    "inviter_avatar": "邀请人头像",
    "inviter_is_merchant": "邀请人是商家",
    "inviter_is_user": "邀请人是用户",
    "inviter_nickname": "邀请人昵称",
    "invite_you_join": "邀请你加入",
    "invite_you_join_territory": "邀请你加入领地",
    "invite_you_play_territory": "邀请你来领地玩",
    "invite_graph": "邀请关系图",
    "invite_card": "邀请卡片",
    "invite_friends": "邀请好友",
    "invite_friends_share_card": "邀请好友分享卡片",
    "invite_friends_join_community": "邀请好友加入社群",
    "invite_friends_join_territory": "邀请好友加入领地",
    "invite_friends_button": "邀请好友按钮",
    "person_who_invited_me": "邀请我的人",
    "invite_hint": "邀请提示",
    "invite_user_card_template": "邀请用户卡片模板",
    "invite_code": "邀请码",
    "invite_code_not_exist": "邀请码不存在",
    "invite_code_empty": "邀请码为空",
    "invite_code_copied": "邀请码已复制",
    "invite_code_copied_clipboard": "邀请码已复制到剪贴板",
    "partially_used": "部分使用",
    "partially_shipped": "部分发货",
    "partially_batch_event_failed": "部分批量事件发送失败",
    "everyone_has_territory": "都有自己的领地",
    "make_territory_prosperous": "都让领地更繁荣",
    "config": "配置",
    "config_updated": "配置已更新",
    "config_update": "配置更新",
    "delivery_method_switch": "配送方式切换",
    "pub": "酒吧",
    "adopt": "采用",
    "overlapping_avatars": "重叠的头像",
    "chongqing_impression_city": "重庆印象城",
    "chongqing_city": "重庆市",
    "rejoin_queue": "重新加入队列",
    "resend": "重新发送",
    "repay": "重新支付",
    "retry": "重试",
    "retry_too_many_times": "重试次数过多",
    "amount_info": "金额信息",
    "amount_display": "金额展示",
    "amount_show": "金额显示",
    "lobster_supreme": "金鳌虾至尊",
    "wallet_address": "钱包地址",
    "diamond": "钻",
    "diamond_alt": "钻石",
    "diamond_navigator": "钻石领航员",
    "bank_card_upload": "银行卡上传",
    "bank_card_doc_upload": "银行卡件上传",
    "bank_card_info": "银行卡信息",
    "bank_card_form": "银行卡信息表单",
    "bank_card_front": "银行卡正面",
    "mint_date": "铸造日期",
    "chain_address": "链上地址",
    "link_empty": "链接为空",
    "link_failed": "链接失败",
    "link_copied": "链接已复制",
    "link_copied_clipboard": "链接已复制到剪贴板",
    "link_generating": "链接生成中",
    "sales_volume": "销量",
    "sales_over": "销量超",
    "error": "错误",
    "error_banner": "错误提示横幅",
    "error_state": "错误状态",
    "length_exceed_limit": "长度超过限制",
    "long_press_qrcode": "长按二维码",
    "long_press_modal": "长按弹窗组件",
    "long_press_view_detail": "长按查看详情",
    "long_press_recognize": "长按识别",
    "long_term": "长期",
    "long_term_valid": "长期有效",
    "long_term_no_end_time": "长期有效期无需选择结束时间",
    "changsha_city": "长沙市",
    "store": "门店",
    "store_type": "门店业态",
    "store_type_picker": "门店业态选择器弹窗",
    "store_location": "门店位置",
    "store_info": "门店信息",
    "store_info_display": "门店信息展示",
    "store_settle_in": "门店入驻",
    "store_card_template": "门店卡片模板",
    "store_name": "门店名称",
    "store_image": "门店图片",
    "store_desc": "门店描述",
    "store_activity": "门店活动",
    "store_phone": "门店电话",
    "store_manager": "门店负责人",
    "store_selection_square": "门店选品广场",
    "prevent_content_blocked_navbar": "防止内容被导航栏遮挡",
    "nearby_places_list": "附近地点列表",
    "downgrade_to_myapp": "降级到应用宝",
    "downgrade_button": "降级按钮",
    "limit": "限制",
    "limit_dine_in": "限堂食",
    "limited": "限定",
    "flash_sale": "限时抢购",
    "limited_time_offer": "限时特惠",
    "purchase_limit": "限购",
    "limited_quantity": "限量",
    "limited_sale": "限量发售",
    "limited_new_product": "限量新品",
    "use_freely": "随便用",
    "refund_anytime": "随时退",
    "privacy_protocol": "隐私协议",
    "privacy_policy": "隐私政策",
    "hide": "隐藏",
    "hide_render": "隐藏渲染",
    "gathered_people": "集齐人数",
    "retail": "零售",
    "retail_product_detail": "零售商品详情",
    "retail_confirm_order": "零售确认订单",
    "retail_order_detail": "零售订单详情",
    "retail_detail": "零售详情",
    "radar_chart": "雷达图",
    "demand_match": "需求速配",
    "need_calendar_permission_add_reminder": "需要日历权限才能添加预约提醒",
    "need_calendar_permission_add_reminder_alt": "需要日历权限来添加预约提醒",
    "need_album_permission_save_image": "需要相册权限才能保存图片",
    "need_self_obtain": "需要自行获取",
    "need_location_permission": "需要获取您的位置权限",
    "non_distributor_status": "非分销员状态",
    "non_miniapp_show_cart": "非小程序环境显示选品车入口",
    "expect_interesting_stories": "非常期待今天能和朋友们发生一些有趣的故事和互动",
    "placeholder_non_wechat_or_unready": "非微信内或未就绪时的占位",
    "show_only_non_wechat": "非微信环境才显示",
    "non_express_order": "非快递订单",
    "non_business_hours": "非营业时间",
    "non_auth_digital_product_user_info_none": "非认证和数字商品类型以及用户信息无",
    "panel": "面板",
    "page_content": "页面内容",
    "page_loading_state": "页面加载状态",
    "page_header": "页面头部",
    "page_starts_rendering": "页面开始渲染",
    "page_visit": "页面访问",
    "top_switch_bar": "顶部切换栏",
    "top_area": "顶部区域",
    "top_avatar_blessing": "顶部头像和祝福",
    "top_navbar": "顶部导航栏",
    "top_recommend_area": "顶部推荐区域",
    "top_text": "顶部文字",
    "top_bg_card": "顶部背景卡片",
    "top_custom_navbar": "顶部自定义导航栏",
    "top_decoration_bg": "顶部装饰背景",
    "top_invite_text": "顶部邀请文字",
    "notice": "须知",
    "estimated": "预估",
    "estimated_commission": "预估佣金",
    "estimated_commission_modal": "预估佣金说明弹窗",
    "estimated_revenue": "预估收益",
    "estimated_max_earn": "预估最高赚",
    "reserved_phone": "预留手机号",
    "reservation_person": "预约人",
    "reservation_count": "预约人数",
    "reservation_success": "预约成功",
    "reservation_rank": "预约排行榜",
    "reservation_ranking": "预约榜",
    "estimated_discount": "预计优惠",
    "estimated_commission_total": "预计已售卖且可分佣订单确认收货或核销后可赚佣金总额",
    "lord": "领主",
    "claim": "领取",
    "claim_exclusive_welfare": "领取你的专属福利",
    "claim_exclusive_red_packet": "领取你的专属红包",
    "claim_list": "领取列表",
    "after_claim": "领取后",
    "claim_reward_success": "领取奖励成功",
    "claim_success": "领取成功",
    "claim_button": "领取按钮",
    "claim_status": "领取状态",
    "claim_territory_id_join": "领取领地数字身份并加入领地",
    "territory": "领地",
    "territory_intro": "领地介绍",
    "territory_task": "领地任务",
    "territory_info": "领地信息",
    "territory_value": "领地值",
    "territory_share_card": "领地分享卡片",
    "territory_share_modal": "领地分享弹窗",
    "territory_distribution_class": "领地分销课堂",
    "territory_list": "领地列表",
    "territory_moment": "领地动态",
    "territory_card_template": "领地卡片模板",
    "territory_create_success": "领地即可创建成功",
    "territory_unveil_soon": "领地即将揭幕",
    "territory_original": "领地原创",
    "territory_no": "领地号",
    "territory_name": "领地名称",
    "territory_start": "领地启程",
    "territory_avatar": "领地头像",
    "territory_service": "领地客服",
    "territory_square": "领地广场",
    "territory_member": "领地成员",
    "territory_member_count": "领地成员数",
    "territory_member_tag": "领地成员标签",
    "territory_phone": "领地手机号",
    "territory_checkin_miss_you": "领地打卡就差你啦",
    "territory_promise_privacy": "领地承诺绝不使用或泄露您的实名信息",
    "territory_guide": "领地指南",
    "territory_search": "领地搜索",
    "territory_nft_mall": "领地数字藏品商城",
    "territory_data": "领地数据",
    "territory_showcase": "领地橱窗",
    "territory_activity": "领地活动",
    "territory_user": "领地用户",
    "territory_no_self_create": "领地目前不支持自主创建",
    "territory_code": "领地码",
    "territory_selection": "领地精选",
    "territory_alliance": "领地联营",
    "territory_bg_image": "领地背景图",
    "territory_bg_preview": "领地背景预览",
    "territory_help_user": "领地致力于帮助用户",
    "territory_settings": "领地设置",
    "territory_detail": "领地详情",
    "territory_contribution": "领地贡献值",
    "territory_notice": "领地通知",
    "territory_channel": "领地频道",
    "claim_reward": "领奖励",
    "ling_point": "领点",
    "ling_point_balance": "领点余额",
    "ling_point_deduction": "领点抵扣",
    "ling_point_deduction_display": "领点抵扣展示",
    "ling_point_deducted": "领点抵扣已减",
    "ling_point_red_packet": "领点红包",
    "ling_point_earn_nonstop": "领点赚不停",
    "ling_point_page": "领点页面组件",
    "navigator": "领航员",
    "navigator_digital_asset_order": "领航员数字资产订单",
    "navigator_digital_identity": "领航员数字身份",
    "navigator_earn_per_order": "领航员每单可赚",
    "ling_diamond": "领钻",
    "ling_diamond_balance": "领钻余额",
    "ling_diamond_insufficient": "领钻余额不足",
    "ling_diamond_recharge": "领钻充值",
    "ling_diamond_mall": "领钻商城",
    "ling_diamond_red_packet": "领钻红包",
    "ling_diamond_buy_protocol": "领钻购买协议",
    "channel_pin_top": "频道置顶",
    "stars_count": "颗星星",
    "color_extract_failed": "颜色提取失败",
    "pie_chart": "饼状图",
    "first_post_interaction": "首发帖在线求互动",
    "first_asset": "首发资产",
    "homepage": "首页",
    "show_at_homepage": "首页时显示",
    "open_red_packet_now": "马上拆红包",
    "verify_not_same_person": "验证不是同一个人",
    "verify_code_sent": "验证码已发送",
    "skeleton_loading": "骨架屏加载状态",
    "height_fixed": "高度固定",
    "efficient_management_tool": "高效管理工具",
    "gold_navigator": "黄金领航员",
    "default": "默认",
    "default_is": "默认为",
    "default_group": "默认分组",
    "default_search_icon": "默认搜索图标",
    "default_title": "默认标题",
    "default_gift": "默认礼物",
    "default_empty_template": "默认空白模板",
    "default_back_button": "默认返回按钮",
    "land_activity": "领地活动",
    "land_shop_window": "领地橱窗",
    "land_store": "门店",
    "land_no_store": "暂无门店",
    "land_demand_match": "需求速配",
    "land_ido_square": "IDO广场",
    "land_initial_assets": "首发资产",
    "land_connection_count_suffix": "条人脉",

    // 发布动态页面
    "publish_dynamic": "发布动态",
    "publish": "发布",
    "publishing": "发布中",
    "publish_success": "发布成功",
    "add_title": "添加标题",
    "add_content": "添加正文",
    "link_territory": "关联领地",
    "select_activity_product_store": "选择活动/商品/门店",
    "no_activity_product_store_found": "未找到活动/商品/门店",
    "get_more_rewards": "获得更多收益",
    "discard_edit_confirm": "是否放弃编辑？",
    "select_territory_developing": "选择领地功能开发中",
    "select_activity_developing": "选择活动功能开发中",

    // 选择地点页面
    "search_location": "搜索地点",
    "locating": "定位中",
    "location_failed": "定位失败",
    "searching": "搜索中",
    "please_select_location": "请选择地点",
    "location_permission_required": "需要位置权限",
    "location_permission_desc": "为了提供更好的服务，需要获取您的位置信息。请在浏览器设置中允许访问位置。",
    "go_to_settings": "去设置",
    "use_default_location": "使用默认位置",
    "please_enable_location_in_browser": "请在浏览器设置中开启位置权限",
    "login": "登录",
    "login_to_open_red_packet": "登录后，马上拆红包",
    "welcome_to_territory": "Hi, 欢迎来到领地",
    "auto_register_if_not_registered": "若该手机号未注册,我们将自动为您注册",
    "code_sent_to": "已发送至",
    "cannot_login_try_again": "无法登录？再试一次",
    "please_input_correct_phone": "请输入正确的手机号",
    "please_input_4_digit_code": "请输入4位数字验证码",
    "verify_code_sent": "验证码已发送",
    "send_failed_retry": "发送失败，请重试",
    "logging_in": "登录中...",
    "login_success": "登录成功",
    "user_agreement_territory": "用户协议(领地)",
    "user_agreement_territory_bracket": "《用户协议(领地)》",
    "user_privacy_agreement_territory": "用户隐私协议(领地)",
    "user_privacy_agreement_territory_bracket": "《用户隐私协议(领地)》",
    "add_new_address": "新建地址",
    "edit_address": "编辑地址",
    "please_fill_name": "请填写姓名",
    "please_fill_phone": "请填写手机号",
    "please_fill_detailed_address": "请填写详细地址",
    "home": "家",
    "company": "公司",
    "select_location_failed": "选择位置失败",
    "get_location_failed_check_permission": "获取位置失败，请检查权限",
    "permission_hint": "权限提示",
    "need_location_permission_go_settings": "需要获取您的位置权限，请前往设置开启",
    "get_location_permission_failed": "获取位置权限失败",
    "save_modified_info_confirm": "是否保存修改的信息？",
    "select_country_region": "选择国家/地区",
    "my_address": "我的地址",
    "hong_kong": "香港",
    "macau": "澳门",
    "signature_params_incomplete": "签名参数不完整",
    "year_month_format": "YYYY年MM月",
    "after_year": "后",
    "total_n_items": "共 {n} 条",
    "get_dynamic_params_error": "获取动态参数错误",
    "joined_territory": "他加入的领地",
    "check_my_homepage": "来看看我的主页～",
    "pending_use_receipt": "待使用/待收货",
    "pending_evaluate": "待评价",
    "insufficient_balance": "账户可用余额不足",
    "rights_update_regularly": "权益定期更新",
    "and_earn_commission": "并赚取佣金",
    "and_claim_rewards": "并领取奖励",
    "already_hold_digital_product": "已经持有该数字商品",
    "open_after": "后开启",
    "claim_success_check_wallet": "领取成功，请到个人钱包查看",
    "login_success_paying": "登录成功,正在支付",
    "details": "详情",
    "joint_venture": "联营",
    "from_territory_recommend": "来自{name}的推荐，点击去看看吧~",
    "ido_digital_asset_order": "IDO数字资产订单",
    "goods_service_order": "商品/服务订单",
    "page_back_triggered": "页面返回被触发",
    "paid": "已支付",
    "shipping": "配送中",
    "pending": "待处理",
    "store_preparing": "店铺筹备中",
    "pending_open_shop": "待开店",
    "store_opened": "已开店",
    "store_closed": "已闭店",
    "pending_delivery": "待发货",
    "partial_delivery": "部分发货",
    "partial_used": "部分使用",
    "used": "已使用",
    "expired": "已失效",
    "closed": "已关闭",
    "pending_seller_accept": "待卖家接单",
    "shopping_voucher": "购物券",
    "freight_voucher": "运费券",
    "self_pickup": "打包自提",
    "pending_merchant_confirm": "待商家确认",
    "pending_merchant_refund": "待商家退款",
    "pending_fill_logistics": "待填写物流信息",
    "merchant_rejected_refund": "商家拒绝退款",
    "after_sales_revoked_closed": "您已撤销售后，退款已关闭",
    "return_and_refund": "退货退款",
    "refund_to_wechat": "退回 (微信)",
    "remark": "理由",
    "refund_request_submitted_wait": "您已成功发起退款申请，请耐心等待商家处理",
    "merchant_no_confirm_auto_refund": "后商家未确认，将自动退款",
    "merchant_no_confirm_auto_agree": "后商家未确认，将自动同意售后",
    "issue_not_resolved_reapply_after": "若您的问题尚未解决，可以在",
    "not_shipped_revoke_return": "后未寄出将撤销退货申请",
    "merchant_no_refund_auto_refund": "后商家未退款，将自动退款给您",
    "reapply_after_sales": "后再次申请售后",
    "cancel_revoke": "暂不撤销",
    "revoke_after_sales_retry": "撤销售后失败，请稍后重试",
    "remaining_payment_time": "剩余支付时间",
    "order_no": "订单编号",
    "cancel_time": "取消时间",
    "you_have_points": "您当前有{count}领点",
    "use_points_deduct": "使用{points}领点抵扣{amount}元",
    "confirm_receipt_success": "确认收货成功",
    "refunding": "退款中...",
    "refund_apply_submitted": "退款申请已提交",
    "refund_apply_failed": "退款申请失败",
    "operation_failed_retry": "操作失败，请重试",
    "refund_success": "退款成功",
    "refund_failed": "退款失败",
    "select_after_sales_reason": "选择售后原因",
    "balance_insufficient": "账户可用余额不足",
    "full_amount_available": "满{amount}元可用",
    "valid_until": "有效期至",
    "go_to_use": "去使用",
};
